/* different signup route (tab) */
export const VENDOR_SIGNUP = 'vendor-signup';
export const CUSTOMER_SIGNUP = 'customer-signup';
/* different signup route (tab) */

/* different profile settings route (tab) */
export const PROFILE_DEFAULT = 'default';
export const PROFILE_REVIEWS = 'reviews';
export const PROFILE_LISTINGS = 'listings';
export const PROFILE_CERTIFICATES = 'certificates';
/* different profile settings route (tab) */

// export const phoneDialCodeData = [
//   {
//     name: {
//       en: 'Afghanistan',
//       fr: 'Afghanistan',
//     },
//     iso2: 'AF',
//     iso3: 'AFG',
//     dialCode: '+93',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Albania',
//       fr: 'Albanie',
//     },
//     iso2: 'AL',
//     iso3: 'ALB',
//     dialCode: '+355',
//     maxDigit: 8,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Algeria',
//       fr: 'Algérie',
//     },
//     iso2: 'DZ',
//     iso3: 'DZA',
//     dialCode: '+213',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'American Samoa',
//       fr: 'Samoa américaines',
//     },
//     iso2: 'AS',
//     iso3: 'ASM',
//     dialCode: '+1-684',
//     maxDigit: 7,
//     nddPrefix: '1',
//   },
//   {
//     name: {
//       en: 'Andorra',
//       fr: 'Andorre',
//     },
//     iso2: 'AD',
//     iso3: 'AND',
//     dialCode: '+376',
//     maxDigit: 6,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Angola',
//       fr: 'Angola',
//     },
//     iso2: 'AO',
//     iso3: 'AGO',
//     dialCode: '+244',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Anguilla',
//       fr: 'Anguilla',
//     },
//     iso2: 'AI',
//     iso3: 'AIA',
//     dialCode: '+1-264',
//     maxDigit: 7,
//     nddPrefix: '1',
//   },
//   {
//     name: {
//       en: 'Antarctica',
//       fr: 'Antarctique',
//     },
//     iso2: 'AQ',
//     iso3: 'ATA',
//     dialCode: '+672',
//     maxDigit: 10,
//     nddPrefix: null,
//   },
//   {
//     name: {
//       en: 'Antigua and Barbuda',
//       fr: 'Antigua-et-Barbuda',
//     },
//     iso2: 'AG',
//     iso3: 'ATG',
//     dialCode: '+1-268',
//     maxDigit: 7,
//     nddPrefix: '1',
//   },
//   {
//     name: {
//       en: 'Argentina',
//       fr: 'Argentine',
//     },
//     iso2: 'AR',
//     iso3: 'ARG',
//     dialCode: '+54',
//     maxDigit: 10,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Armenia',
//       fr: 'Arménie',
//     },
//     iso2: 'AM',
//     iso3: 'ARM',
//     dialCode: '+374',
//     maxDigit: 8,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Aruba',
//       fr: 'Aruba',
//     },
//     iso2: 'AW',
//     iso3: 'ABW',
//     dialCode: '+297',
//     maxDigit: 7,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Australia',
//       fr: 'Australie',
//     },
//     iso2: 'AU',
//     iso3: 'AUS',
//     dialCode: '+61',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Austria',
//       fr: 'Autriche',
//     },
//     iso2: 'AT',
//     iso3: 'AUT',
//     dialCode: '+43',
//     maxDigit: 10,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Azerbaijan',
//       fr: 'Azerbaïdjan',
//     },
//     iso2: 'AZ',
//     iso3: 'AZE',
//     dialCode: '+994',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Bahamas',
//       fr: 'Bahamas',
//     },
//     iso2: 'BS',
//     iso3: 'BHS',
//     dialCode: '+1-242',
//     maxDigit: 7,
//     nddPrefix: '1',
//   },
//   {
//     name: {
//       en: 'Bahrain',
//       fr: 'Bahreïn',
//     },
//     iso2: 'BH',
//     iso3: 'BHR',
//     dialCode: '+973',
//     maxDigit: 8,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Bangladesh',
//       fr: 'Bangladesh',
//     },
//     iso2: 'BD',
//     iso3: 'BGD',
//     dialCode: '+880',
//     maxDigit: 10,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Barbados',
//       fr: 'Barbade',
//     },
//     iso2: 'BB',
//     iso3: 'BRB',
//     dialCode: '+1-246',
//     maxDigit: 7,
//     nddPrefix: '1',
//   },
//   {
//     name: {
//       en: 'Belarus',
//       fr: 'Bélarus',
//     },
//     iso2: 'BY',
//     iso3: 'BLR',
//     dialCode: '+375',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Belgium',
//       fr: 'Belgique',
//     },
//     iso2: 'BE',
//     iso3: 'BEL',
//     dialCode: '+32',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Belize',
//       fr: 'Belize',
//     },
//     iso2: 'BZ',
//     iso3: 'BLZ',
//     dialCode: '+501',
//     maxDigit: 7,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Benin',
//       fr: 'Bénin',
//     },
//     iso2: 'BJ',
//     iso3: 'BEN',
//     dialCode: '+229',
//     maxDigit: 8,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Bermuda',
//       fr: 'Bermudes',
//     },
//     iso2: 'BM',
//     iso3: 'BMU',
//     dialCode: '+1-441',
//     maxDigit: 7,
//     nddPrefix: '1',
//   },
//   {
//     name: {
//       en: 'Bhutan',
//       fr: 'Bhoutan',
//     },
//     iso2: 'BT',
//     iso3: 'BTN',
//     dialCode: '+975',
//     maxDigit: 8,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Bolivia',
//       fr: 'Bolivie',
//     },
//     iso2: 'BO',
//     iso3: 'BOL',
//     dialCode: '+591',
//     maxDigit: 8,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Bosnia and Herzegovina',
//       fr: 'Bosnie-Herzégovine',
//     },
//     iso2: 'BA',
//     iso3: 'BIH',
//     dialCode: '+387',
//     maxDigit: 8,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Botswana',
//       fr: 'Botswana',
//     },
//     iso2: 'BW',
//     iso3: 'BWA',
//     dialCode: '+267',
//     maxDigit: 8,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Brazil',
//       fr: 'Brésil',
//     },
//     iso2: 'BR',
//     iso3: 'BRA',
//     dialCode: '+55',
//     maxDigit: 11,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'British Indian Ocean Territory',
//       fr: "Territoire britannique de l'océan Indien",
//     },
//     iso2: 'IO',
//     iso3: 'IOT',
//     dialCode: '+246',
//     maxDigit: 7,
//     nddPrefix: null,
//   },
//   {
//     name: {
//       en: 'British Virgin Islands',
//       fr: 'Îles Vierges britanniques',
//     },
//     iso2: 'VG',
//     iso3: 'VGB',
//     dialCode: '+1-284',
//     maxDigit: 7,
//     nddPrefix: '1',
//   },
//   {
//     name: {
//       en: 'Brunei',
//       fr: 'Brunei',
//     },
//     iso2: 'BN',
//     iso3: 'BRN',
//     dialCode: '+673',
//     maxDigit: 7,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Bulgaria',
//       fr: 'Bulgarie',
//     },
//     iso2: 'BG',
//     iso3: 'BGR',
//     dialCode: '+359',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Burkina Faso',
//       fr: 'Burkina Faso',
//     },
//     iso2: 'BF',
//     iso3: 'BFA',
//     dialCode: '+226',
//     maxDigit: 8,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Burundi',
//       fr: 'Burundi',
//     },
//     iso2: 'BI',
//     iso3: 'BDI',
//     dialCode: '+257',
//     maxDigit: 8,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Cambodia',
//       fr: 'Cambodge',
//     },
//     iso2: 'KH',
//     iso3: 'KHM',
//     dialCode: '+855',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Cameroon',
//       fr: 'Cameroun',
//     },
//     iso2: 'CM',
//     iso3: 'CMR',
//     dialCode: '+237',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Canada',
//       fr: 'Canada',
//     },
//     iso2: 'CA',
//     iso3: 'CAN',
//     dialCode: '+1',
//     maxDigit: 10,
//     nddPrefix: '1',
//   },
//   {
//     name: {
//       en: 'Cape Verde',
//       fr: 'Cap-Vert',
//     },
//     iso2: 'CV',
//     iso3: 'CPV',
//     dialCode: '+238',
//     maxDigit: 7,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Cayman Islands',
//       fr: 'Îles Caïmans',
//     },
//     iso2: 'KY',
//     iso3: 'CYM',
//     dialCode: '+1-345',
//     maxDigit: 7,
//     nddPrefix: '1',
//   },
//   {
//     name: {
//       en: 'Central African Republic',
//       fr: 'République Centrafricaine',
//     },
//     iso2: 'CF',
//     iso3: 'CAF',
//     dialCode: '+236',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Chad',
//       fr: 'Tchad',
//     },
//     iso2: 'TD',
//     iso3: 'TCD',
//     dialCode: '+235',
//     maxDigit: 8,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Chile',
//       fr: 'Chili',
//     },
//     iso2: 'CL',
//     iso3: 'CHL',
//     dialCode: '+56',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'China',
//       fr: 'Chine',
//     },
//     iso2: 'CN',
//     iso3: 'CHN',
//     dialCode: '+86',
//     maxDigit: 11,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Christmas Island',
//       fr: 'Île Christmas',
//     },
//     iso2: 'CX',
//     iso3: 'CXR',
//     dialCode: '+61',
//     maxDigit: 8,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Cocos (Keeling) Islands',
//       fr: 'Îles Cocos (Keeling)',
//     },
//     iso2: 'CC',
//     iso3: 'CCK',
//     dialCode: '+61',
//     maxDigit: 8,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Colombia',
//       fr: 'Colombie',
//     },
//     iso2: 'CO',
//     iso3: 'COL',
//     dialCode: '+57',
//     maxDigit: 10,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Comoros',
//       fr: 'Comores',
//     },
//     iso2: 'KM',
//     iso3: 'COM',
//     dialCode: '+269',
//     maxDigit: 7,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Cook Islands',
//       fr: 'Îles Cook',
//     },
//     iso2: 'CK',
//     iso3: 'COK',
//     dialCode: '+682',
//     maxDigit: 5,
//     nddPrefix: null,
//   },
//   {
//     name: {
//       en: 'Congo (Congo-Brazzaville)',
//       fr: 'Congo (Congo-Brazzaville)',
//     },
//     iso2: 'CG',
//     iso3: 'COG',
//     dialCode: '+242',
//     maxDigit: 8,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Congo (Democratic Republic)',
//       fr: 'Congo (République Démocratique)',
//     },
//     iso2: 'CD',
//     iso3: 'COD',
//     dialCode: '+243',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Costa Rica',
//       fr: 'Costa Rica',
//     },
//     iso2: 'CR',
//     iso3: 'CRI',
//     dialCode: '+506',
//     maxDigit: 8,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: "Cote d'Ivoire (Ivory Coast)",
//       fr: "Côte d'Ivoire (Côte d'Ivoire)",
//     },
//     iso2: 'CI',
//     iso3: 'CIV',
//     dialCode: '+225',
//     maxDigit: 8,
//     nddPrefix: '',
//   },
//   {
//     name: {
//       en: 'Croatia',
//       fr: 'Croatie',
//     },
//     iso2: 'HR',
//     iso3: 'HRV',
//     dialCode: '+385',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Cuba',
//       fr: 'Cuba',
//     },
//     iso2: 'CU',
//     iso3: 'CUB',
//     dialCode: '+53',
//     maxDigit: 8,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Curaçao',
//       fr: 'Curaçao',
//     },
//     iso2: 'CW',
//     iso3: 'CUW',
//     dialCode: '+599',
//     maxDigit: 7,
//     nddPrefix: null,
//   },
//   {
//     name: {
//       en: 'Cyprus',
//       fr: 'Chypre',
//     },
//     iso2: 'CY',
//     iso3: 'CYP',
//     dialCode: '+357',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Czech Republic',
//       fr: 'République tchèque',
//     },
//     iso2: 'CZ',
//     iso3: 'CZE',
//     dialCode: '+420',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Denmark',
//       fr: 'Danemark',
//     },
//     iso2: 'DK',
//     iso3: 'DNK',
//     dialCode: '+45',
//     maxDigit: 8,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Djibouti',
//       fr: 'Djibouti',
//     },
//     iso2: 'DJ',
//     iso3: 'DJI',
//     dialCode: '+253',
//     maxDigit: 8,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Dominica',
//       fr: 'Dominique',
//     },
//     iso2: 'DM',
//     iso3: 'DMA',
//     dialCode: '+1-767',
//     maxDigit: 7,
//     nddPrefix: '1',
//   },
//   {
//     name: {
//       en: 'Dominican Republic',
//       fr: 'République Dominicaine',
//     },
//     iso2: 'DO',
//     iso3: 'DOM',
//     dialCode: '+1-809',
//     maxDigit: 10,
//     nddPrefix: '1',
//   },
//   {
//     name: {
//       en: 'East Timor(Timor-Leste)',
//       fr: 'Timor oriental (Timor-Leste)',
//     },
//     iso2: 'TL',
//     iso3: 'TLS',
//     dialCode: '+670',
//     maxDigit: 8,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Ecuador',
//       fr: 'Équateur',
//     },
//     iso2: 'EC',
//     iso3: 'ECU',
//     dialCode: '+593',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Egypt',
//       fr: 'Égypte',
//     },
//     iso2: 'EG',
//     iso3: 'EGY',
//     dialCode: '+20',
//     maxDigit: 10,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'El Salvador',
//       fr: 'Salvador',
//     },
//     iso2: 'SV',
//     iso3: 'SLV',
//     dialCode: '+503',
//     maxDigit: 8,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Equatorial Guinea',
//       fr: 'Guinée équatoriale',
//     },
//     iso2: 'GQ',
//     iso3: 'GNQ',
//     dialCode: '+240',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Eritrea',
//       fr: 'Érythrée',
//     },
//     iso2: 'ER',
//     iso3: 'ERI',
//     dialCode: '+291',
//     maxDigit: 7,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Estonia',
//       fr: 'Estonie',
//     },
//     iso2: 'EE',
//     iso3: 'EST',
//     dialCode: '+372',
//     maxDigit: 8,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Ethiopia',
//       fr: 'Éthiopie',
//     },
//     iso2: 'ET',
//     iso3: 'ETH',
//     dialCode: '+251',
//     maxDigit: 10,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Falkland Islands',
//       fr: 'Îles Malouines',
//     },
//     iso2: 'FK',
//     iso3: 'FLK',
//     dialCode: '+500',
//     maxDigit: 5,
//     nddPrefix: null,
//   },
//   {
//     name: {
//       en: 'Faroe Islands',
//       fr: 'Îles Féroé',
//     },
//     iso2: 'FO',
//     iso3: 'FRO',
//     dialCode: '+298',
//     maxDigit: 6,
//     nddPrefix: null,
//   },
//   {
//     name: {
//       en: 'Fiji',
//       fr: 'Fidji',
//     },
//     iso2: 'FJ',
//     iso3: 'FJI',
//     dialCode: '+679',
//     maxDigit: 8,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Finland',
//       fr: 'Finlande',
//     },
//     iso2: 'FI',
//     iso3: 'FIN',
//     dialCode: '+358',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'France',
//       fr: 'France',
//     },
//     iso2: 'FR',
//     iso3: 'FRA',
//     dialCode: '+33',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'French Polynesia',
//       fr: 'Polynésie française',
//     },
//     iso2: 'PF',
//     iso3: 'PYF',
//     dialCode: '+689',
//     maxDigit: 8,
//     nddPrefix: null,
//   },
//   {
//     name: {
//       en: 'Eswatini (Swaziland)',
//       fr: 'Eswatini (Swaziland)',
//     },
//     iso2: 'SZ',
//     iso3: 'SWZ',
//     dialCode: '+268',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Gabon',
//       fr: 'Gabon',
//     },
//     iso2: 'GA',
//     iso3: 'GAB',
//     dialCode: '+241',
//     maxDigit: 8,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Gambia',
//       fr: 'Gambie',
//     },
//     iso2: 'GM',
//     iso3: 'GMB',
//     dialCode: '+220',
//     maxDigit: 7,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Georgia',
//       fr: 'Géorgie',
//     },
//     iso2: 'GE',
//     iso3: 'GEO',
//     dialCode: '+995',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Germany',
//       fr: 'Allemagne',
//     },
//     iso2: 'DE',
//     iso3: 'DEU',
//     dialCode: '+49',
//     maxDigit: 11,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Ghana',
//       fr: 'Ghana',
//     },
//     iso2: 'GH',
//     iso3: 'GHA',
//     dialCode: '+233',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Gibraltar',
//       fr: 'Gibraltar',
//     },
//     iso2: 'GI',
//     iso3: 'GIB',
//     dialCode: '+350',
//     maxDigit: 8,
//     nddPrefix: null,
//   },
//   {
//     name: {
//       en: 'Greece',
//       fr: 'Grèce',
//     },
//     iso2: 'GR',
//     iso3: 'GRC',
//     dialCode: '+30',
//     maxDigit: 10,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Greenland',
//       fr: 'Groenland',
//     },
//     iso2: 'GL',
//     iso3: 'GRL',
//     dialCode: '+299',
//     maxDigit: 6,
//     nddPrefix: null,
//   },
//   {
//     name: {
//       en: 'Grenada',
//       fr: 'Grenade',
//     },
//     iso2: 'GD',
//     iso3: 'GRD',
//     dialCode: '+1-473',
//     maxDigit: 7,
//     nddPrefix: '1',
//   },
//   {
//     name: {
//       en: 'Guam',
//       fr: 'Guam',
//     },
//     iso2: 'GU',
//     iso3: 'GUM',
//     dialCode: '+1-671',
//     maxDigit: 7,
//     nddPrefix: '1',
//   },
//   {
//     name: {
//       en: 'Guatemala',
//       fr: 'Guatemala',
//     },
//     iso2: 'GT',
//     iso3: 'GTM',
//     dialCode: '+502',
//     maxDigit: 8,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Guernsey',
//       fr: 'Guernesey',
//     },
//     iso2: 'GG',
//     iso3: 'GGY',
//     dialCode: '+44-1481',
//     maxDigit: 6,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Guinea',
//       fr: 'Guinée',
//     },
//     iso2: 'GN',
//     iso3: 'GIN',
//     dialCode: '+224',
//     maxDigit: 8,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Guinea-Bissau',
//       fr: 'Guinée-Bissau',
//     },
//     iso2: 'GW',
//     iso3: 'GNB',
//     dialCode: '+245',
//     maxDigit: 7,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Guyana',
//       fr: 'Guyane',
//     },
//     iso2: 'GY',
//     iso3: 'GUY',
//     dialCode: '+592',
//     maxDigit: 7,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Haiti',
//       fr: 'Haïti',
//     },
//     iso2: 'HT',
//     iso3: 'HTI',
//     dialCode: '+509',
//     maxDigit: 8,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Honduras',
//       fr: 'Honduras',
//     },
//     iso2: 'HN',
//     iso3: 'HND',
//     dialCode: '+504',
//     maxDigit: 8,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Hong Kong',
//       fr: 'Hong Kong',
//     },
//     iso2: 'HK',
//     iso3: 'HKG',
//     dialCode: '+852',
//     maxDigit: 8,
//     nddPrefix: '',
//   },
//   {
//     name: {
//       en: 'Hungary',
//       fr: 'Hongrie',
//     },
//     iso2: 'HU',
//     iso3: 'HUN',
//     dialCode: '+36',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Iceland',
//       fr: 'Islande',
//     },
//     iso2: 'IS',
//     iso3: 'ISL',
//     dialCode: '+354',
//     maxDigit: 7,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'India',
//       fr: 'Inde',
//     },
//     iso2: 'IN',
//     iso3: 'IND',
//     dialCode: '+91',
//     maxDigit: 10,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Indonesia',
//       fr: 'Indonésie',
//     },
//     iso2: 'ID',
//     iso3: 'IDN',
//     dialCode: '+62',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Iran',
//       fr: 'Iran',
//     },
//     iso2: 'IR',
//     iso3: 'IRN',
//     dialCode: '+98',
//     maxDigit: 10,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Iraq',
//       fr: 'Irak',
//     },
//     iso2: 'IQ',
//     iso3: 'IRQ',
//     dialCode: '+964',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Ireland',
//       fr: 'Irlande',
//     },
//     iso2: 'IE',
//     iso3: 'IRL',
//     dialCode: '+353',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Isle of Man',
//       fr: 'Île de Man',
//     },
//     iso2: 'IM',
//     iso3: 'IMN',
//     dialCode: '+44-1624',
//     maxDigit: 6,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Israel',
//       fr: 'Israël',
//     },
//     iso2: 'IL',
//     iso3: 'ISR',
//     dialCode: '+972',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Italy',
//       fr: 'Italie',
//     },
//     iso2: 'IT',
//     iso3: 'ITA',
//     dialCode: '+39',
//     maxDigit: 10,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Jamaica',
//       fr: 'Jamaïque',
//     },
//     iso2: 'JM',
//     iso3: 'JAM',
//     dialCode: '+1-876',
//     maxDigit: 7,
//     nddPrefix: '1',
//   },
//   {
//     name: {
//       en: 'Japan',
//       fr: 'Japon',
//     },
//     iso2: 'JP',
//     iso3: 'JPN',
//     dialCode: '+81',
//     maxDigit: 10,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Jersey',
//       fr: 'Jersey',
//     },
//     iso2: 'JE',
//     iso3: 'JEY',
//     dialCode: '+44-1534',
//     maxDigit: 10,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Jordan',
//       fr: 'Jordanie',
//     },
//     iso2: 'JO',
//     iso3: 'JOR',
//     dialCode: '+962',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Kazakhstan',
//       fr: 'Kazakhstan',
//     },
//     iso2: 'KZ',
//     iso3: 'KAZ',
//     dialCode: '+7',
//     maxDigit: 10,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Kenya',
//       fr: 'Kenya',
//     },
//     iso2: 'KE',
//     iso3: 'KEN',
//     dialCode: '+254',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Kiribati',
//       fr: 'Kiribati',
//     },
//     iso2: 'KI',
//     iso3: 'KIR',
//     dialCode: '+686',
//     maxDigit: 7,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Kosovo',
//       fr: 'Kosovo',
//     },
//     iso2: 'XK',
//     iso3: 'XKX',
//     dialCode: '+383',
//     maxDigit: 8,
//     nddPrefix: null,
//   },
//   {
//     name: {
//       en: 'Korea (North)',
//       fr: 'Corée du Nord',
//     },
//     iso2: 'KP',
//     iso3: 'PRK',
//     dialCode: '+850',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Korea (South)',
//       fr: 'Corée du Sud',
//     },
//     iso2: 'KR',
//     iso3: 'KOR',
//     dialCode: '+82',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Kuwait',
//       fr: 'Koweït',
//     },
//     iso2: 'KW',
//     iso3: 'KWT',
//     dialCode: '+965',
//     maxDigit: 8,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Kyrgyzstan',
//       fr: 'Kirghizistan',
//     },
//     iso2: 'KG',
//     iso3: 'KGZ',
//     dialCode: '+996',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Laos',
//       fr: 'Laos',
//     },
//     iso2: 'LA',
//     iso3: 'LAO',
//     dialCode: '+856',
//     maxDigit: 8,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Latvia',
//       fr: 'Lettonie',
//     },
//     iso2: 'LV',
//     iso3: 'LVA',
//     dialCode: '+371',
//     maxDigit: 8,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Lebanon',
//       fr: 'Liban',
//     },
//     iso2: 'LB',
//     iso3: 'LBN',
//     dialCode: '+961',
//     maxDigit: 8,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Lesotho',
//       fr: 'Lesotho',
//     },
//     iso2: 'LS',
//     iso3: 'LSO',
//     dialCode: '+266',
//     maxDigit: 8,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Liberia',
//       fr: 'Liberia',
//     },
//     iso2: 'LR',
//     iso3: 'LBR',
//     dialCode: '+231',
//     maxDigit: 8,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Libya',
//       fr: 'Libye',
//     },
//     iso2: 'LY',
//     iso3: 'LBY',
//     dialCode: '+218',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Liechtenstein',
//       fr: 'Liechtenstein',
//     },
//     iso2: 'LI',
//     iso3: 'LIE',
//     dialCode: '+423',
//     maxDigit: 8,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Lithuania',
//       fr: 'Lituanie',
//     },
//     iso2: 'LT',
//     iso3: 'LTU',
//     dialCode: '+370',
//     maxDigit: 8,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Luxembourg',
//       fr: 'Luxembourg',
//     },
//     iso2: 'LU',
//     iso3: 'LUX',
//     dialCode: '+352',
//     maxDigit: 8,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Macao (SAR China)',
//       fr: 'Macao (RAS Chine)',
//     },
//     iso2: 'MO',
//     iso3: 'MAC',
//     dialCode: '+853',
//     maxDigit: 8,
//     nddPrefix: null,
//   },
//   {
//     name: {
//       en: 'Madagascar',
//       fr: 'Madagascar',
//     },
//     iso2: 'MG',
//     iso3: 'MDG',
//     dialCode: '+261',
//     maxDigit: 8,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Malawi',
//       fr: 'Malawi',
//     },
//     iso2: 'MW',
//     iso3: 'MWI',
//     dialCode: '+265',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Malaysia',
//       fr: 'Malaisie',
//     },
//     iso2: 'MY',
//     iso3: 'MYS',
//     dialCode: '+60',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Maldives',
//       fr: 'Maldives',
//     },
//     iso2: 'MV',
//     iso3: 'MDV',
//     dialCode: '+960',
//     maxDigit: 7,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Mali',
//       fr: 'Mali',
//     },
//     iso2: 'ML',
//     iso3: 'MLI',
//     dialCode: '+223',
//     maxDigit: 8,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Malta',
//       fr: 'Malte',
//     },
//     iso2: 'MT',
//     iso3: 'MLT',
//     dialCode: '+356',
//     maxDigit: 8,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Marshall Islands',
//       fr: 'Îles Marshall',
//     },
//     iso2: 'MH',
//     iso3: 'MHL',
//     dialCode: '+692',
//     maxDigit: 7,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Mauritania',
//       fr: 'Mauritanie',
//     },
//     iso2: 'MR',
//     iso3: 'MRT',
//     dialCode: '+222',
//     maxDigit: 8,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Mauritius',
//       fr: 'Île Maurice',
//     },
//     iso2: 'MU',
//     iso3: 'MUS',
//     dialCode: '+230',
//     maxDigit: 8,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Mayotte',
//       fr: 'Mayotte',
//     },
//     iso2: 'YT',
//     iso3: 'MYT',
//     dialCode: '+262',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Mexico',
//       fr: 'Mexique',
//     },
//     iso2: 'MX',
//     iso3: 'MEX',
//     dialCode: '+52',
//     maxDigit: 10,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Micronesia',
//       fr: 'Micronésie',
//     },
//     iso2: 'FM',
//     iso3: 'FSM',
//     dialCode: '+691',
//     maxDigit: 7,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Moldova',
//       fr: 'Moldavie',
//     },
//     iso2: 'MD',
//     iso3: 'MDA',
//     dialCode: '+373',
//     maxDigit: 8,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Monaco',
//       fr: 'Monaco',
//     },
//     iso2: 'MC',
//     iso3: 'MCO',
//     dialCode: '+377',
//     maxDigit: 8,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Mongolia',
//       fr: 'Mongolie',
//     },
//     iso2: 'MN',
//     iso3: 'MNG',
//     dialCode: '+976',
//     maxDigit: 8,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Montenegro',
//       fr: 'Monténégro',
//     },
//     iso2: 'ME',
//     iso3: 'MNE',
//     dialCode: '+382',
//     maxDigit: 8,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Montserrat',
//       fr: 'Montserrat',
//     },
//     iso2: 'MS',
//     iso3: 'MSR',
//     dialCode: '+1-664',
//     maxDigit: 7,
//     nddPrefix: '1',
//   },
//   {
//     name: {
//       en: 'Morocco',
//       fr: 'Maroc',
//     },
//     iso2: 'MA',
//     iso3: 'MAR',
//     dialCode: '+212',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Mozambique',
//       fr: 'Mozambique',
//     },
//     iso2: 'MZ',
//     iso3: 'MOZ',
//     dialCode: '+258',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Myanmar',
//       fr: 'Birmanie',
//     },
//     iso2: 'MM',
//     iso3: 'MMR',
//     dialCode: '+95',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Namibia',
//       fr: 'Namibie',
//     },
//     iso2: 'NA',
//     iso3: 'NAM',
//     dialCode: '+264',
//     maxDigit: 8,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Nauru',
//       fr: 'Nauru',
//     },
//     iso2: 'NR',
//     iso3: 'NRU',
//     dialCode: '+674',
//     maxDigit: 7,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Nepal',
//       fr: 'Népal',
//     },
//     iso2: 'NP',
//     iso3: 'NPL',
//     dialCode: '+977',
//     maxDigit: 10,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Netherlands',
//       fr: 'Pays-Bas',
//     },
//     iso2: 'NL',
//     iso3: 'NLD',
//     dialCode: '+31',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Netherlands Antilles',
//       fr: 'Antilles néerlandaises',
//     },
//     iso2: 'AN',
//     iso3: 'ANT',
//     dialCode: '+599',
//     maxDigit: 7,
//     nddPrefix: null,
//   },
//   {
//     name: {
//       en: 'New Caledonia',
//       fr: 'Nouvelle-Calédonie',
//     },
//     iso2: 'NC',
//     iso3: 'NCL',
//     dialCode: '+687',
//     maxDigit: 6,
//     nddPrefix: null,
//   },
//   {
//     name: {
//       en: 'New Zealand',
//       fr: 'Nouvelle-Zélande',
//     },
//     iso2: 'NZ',
//     iso3: 'NZL',
//     dialCode: '+64',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Nicaragua',
//       fr: 'Nicaragua',
//     },
//     iso2: 'NI',
//     iso3: 'NIC',
//     dialCode: '+505',
//     maxDigit: 8,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Niger',
//       fr: 'Niger',
//     },
//     iso2: 'NE',
//     iso3: 'NER',
//     dialCode: '+227',
//     maxDigit: 8,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Nigeria',
//       fr: 'Nigeria',
//     },
//     iso2: 'NG',
//     iso3: 'NGA',
//     dialCode: '+234',
//     maxDigit: 10,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Niue',
//       fr: 'Niue',
//     },
//     iso2: 'NU',
//     iso3: 'NIU',
//     dialCode: '+683',
//     maxDigit: 4,
//     nddPrefix: '',
//   },
//   {
//     name: {
//       en: 'Northern Mariana Islands',
//       fr: 'Îles Mariannes du Nord',
//     },
//     iso2: 'MP',
//     iso3: 'MNP',
//     dialCode: '+1-670',
//     maxDigit: 7,
//     nddPrefix: '1',
//   },
//   {
//     name: {
//       en: 'North Macedonia',
//       fr: 'Macédoine du Nord',
//     },
//     iso2: 'MK',
//     iso3: 'MKD',
//     dialCode: '+389',
//     maxDigit: 8,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Norway',
//       fr: 'Norvège',
//     },
//     iso2: 'NO',
//     iso3: 'NOR',
//     dialCode: '+47',
//     maxDigit: 8,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Oman',
//       fr: 'Oman',
//     },
//     iso2: 'OM',
//     iso3: 'OMN',
//     dialCode: '+968',
//     maxDigit: 8,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Pakistan',
//       fr: 'Pakistan',
//     },
//     iso2: 'PK',
//     iso3: 'PAK',
//     dialCode: '+92',
//     maxDigit: 10,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Palau',
//       fr: 'Palaos',
//     },
//     iso2: 'PW',
//     iso3: 'PLW',
//     dialCode: '+680',
//     maxDigit: 7,
//     nddPrefix: '',
//   },
//   {
//     name: {
//       en: 'Palestine',
//       fr: 'Palestine',
//     },
//     iso2: 'PS',
//     iso3: 'PSE',
//     dialCode: '+970',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Panama',
//       fr: 'Panama',
//     },
//     iso2: 'PA',
//     iso3: 'PAN',
//     dialCode: '+507',
//     maxDigit: 8,
//     nddPrefix: '',
//   },
//   {
//     name: {
//       en: 'Papua New Guinea',
//       fr: 'Papouasie-Nouvelle-Guinée',
//     },
//     iso2: 'PG',
//     iso3: 'PNG',
//     dialCode: '+675',
//     maxDigit: 8,
//     nddPrefix: '',
//   },
//   {
//     name: {
//       en: 'Paraguay',
//       fr: 'Paraguay',
//     },
//     iso2: 'PY',
//     iso3: 'PRY',
//     dialCode: '+595',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Peru',
//       fr: 'Pérou',
//     },
//     iso2: 'PE',
//     iso3: 'PER',
//     dialCode: '+51',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Philippines',
//       fr: 'Philippines',
//     },
//     iso2: 'PH',
//     iso3: 'PHL',
//     dialCode: '+63',
//     maxDigit: 10,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Pitcairn Islands',
//       fr: 'Îles Pitcairn',
//     },
//     iso2: 'PN',
//     iso3: 'PCN',
//     dialCode: '+64',
//     maxDigit: 5,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Poland',
//       fr: 'Pologne',
//     },
//     iso2: 'PL',
//     iso3: 'POL',
//     dialCode: '+48',
//     maxDigit: 9,
//     nddPrefix: '',
//   },
//   {
//     name: {
//       en: 'Portugal',
//       fr: 'Portugal',
//     },
//     iso2: 'PT',
//     iso3: 'PRT',
//     dialCode: '+351',
//     maxDigit: 9,
//     nddPrefix: '',
//   },
//   {
//     name: {
//       en: 'Puerto Rico',
//       fr: 'Porto Rico',
//     },
//     iso2: 'PR',
//     iso3: 'PRI',
//     dialCode: '+1-787',
//     maxDigit: 7,
//     nddPrefix: '1',
//   },
//   {
//     name: {
//       en: 'Qatar',
//       fr: 'Qatar',
//     },
//     iso2: 'QA',
//     iso3: 'QAT',
//     dialCode: '+974',
//     maxDigit: 8,
//     nddPrefix: '',
//   },
//   {
//     name: {
//       en: 'Reunion',
//       fr: 'La Réunion',
//     },
//     iso2: 'RE',
//     iso3: 'REU',
//     dialCode: '+262',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Romania',
//       fr: 'Roumanie',
//     },
//     iso2: 'RO',
//     iso3: 'ROU',
//     dialCode: '+40',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Russia',
//       fr: 'Russie',
//     },
//     iso2: 'RU',
//     iso3: 'RUS',
//     dialCode: '+7',
//     maxDigit: 10,
//     nddPrefix: '8',
//   },
//   {
//     name: {
//       en: 'Rwanda',
//       fr: 'Rwanda',
//     },
//     iso2: 'RW',
//     iso3: 'RWA',
//     dialCode: '+250',
//     maxDigit: 9,
//     nddPrefix: '',
//   },
//   {
//     name: {
//       en: 'Saint Barthelemy',
//       fr: 'Saint-Barthélemy',
//     },
//     iso2: 'BL',
//     iso3: 'BLM',
//     dialCode: '+590',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Saint Helena',
//       fr: 'Sainte-Hélène',
//     },
//     iso2: 'SH',
//     iso3: 'SHN',
//     dialCode: '+290',
//     maxDigit: 4,
//     nddPrefix: null,
//   },
//   {
//     name: {
//       en: 'Saint Kitts and Nevis',
//       fr: 'Saint-Christophe-et-Niévès',
//     },
//     iso2: 'KN',
//     iso3: 'KNA',
//     dialCode: '+1-869',
//     maxDigit: 7,
//     nddPrefix: '',
//   },
//   {
//     name: {
//       en: 'Saint Lucia',
//       fr: 'Sainte-Lucie',
//     },
//     iso2: 'LC',
//     iso3: 'LCA',
//     dialCode: '+1-758',
//     maxDigit: 7,
//     nddPrefix: '',
//   },
//   {
//     name: {
//       en: 'Saint Martin',
//       fr: 'Saint-Martin',
//     },
//     iso2: 'MF',
//     iso3: 'MAF',
//     dialCode: '+590',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Saint Pierre and Miquelon',
//       fr: 'Saint-Pierre-et-Miquelon',
//     },
//     iso2: 'PM',
//     iso3: 'SPM',
//     dialCode: '+508',
//     maxDigit: 6,
//     nddPrefix: null,
//   },
//   {
//     name: {
//       en: 'Saint Vincent and the Grenadines',
//       fr: 'Saint-Vincent-et-les-Grenadines',
//     },
//     iso2: 'VC',
//     iso3: 'VCT',
//     dialCode: '+1-784',
//     maxDigit: 7,
//     nddPrefix: '',
//   },
//   {
//     name: {
//       en: 'Samoa',
//       fr: 'Samoa',
//     },
//     iso2: 'WS',
//     iso3: 'WSM',
//     dialCode: '+685',
//     maxDigit: 7,
//     nddPrefix: '',
//   },
//   {
//     name: {
//       en: 'San Marino',
//       fr: 'Saint-Marin',
//     },
//     iso2: 'SM',
//     iso3: 'SMR',
//     dialCode: '+378',
//     maxDigit: 10,
//     nddPrefix: '',
//   },
//   {
//     name: {
//       en: 'Sao Tome and Principe',
//       fr: 'Sao Tomé-et-Principe',
//     },
//     iso2: 'ST',
//     iso3: 'STP',
//     dialCode: '+239',
//     maxDigit: 7,
//     nddPrefix: '',
//   },
//   {
//     name: {
//       en: 'Saudi Arabia',
//       fr: 'Arabie Saoudite',
//     },
//     iso2: 'SA',
//     iso3: 'SAU',
//     dialCode: '+966',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Senegal',
//       fr: 'Sénégal',
//     },
//     iso2: 'SN',
//     iso3: 'SEN',
//     dialCode: '+221',
//     maxDigit: 9,
//     nddPrefix: '',
//   },
//   {
//     name: {
//       en: 'Serbia',
//       fr: 'Serbie',
//     },
//     iso2: 'RS',
//     iso3: 'SRB',
//     dialCode: '+381',
//     maxDigit: 10,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Seychelles',
//       fr: 'Seychelles',
//     },
//     iso2: 'SC',
//     iso3: 'SYC',
//     dialCode: '+248',
//     maxDigit: 7,
//     nddPrefix: '',
//   },
//   {
//     name: {
//       en: 'Sierra Leone',
//       fr: 'Sierra Leone',
//     },
//     iso2: 'SL',
//     iso3: 'SLE',
//     dialCode: '+232',
//     maxDigit: 8,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Singapore',
//       fr: 'Singapour',
//     },
//     iso2: 'SG',
//     iso3: 'SGP',
//     dialCode: '+65',
//     maxDigit: 8,
//     nddPrefix: '',
//   },
//   {
//     name: {
//       en: 'Sint Maarten (Dutch)',
//       fr: 'Saint-Martin (partie néerlandaise)',
//     },
//     iso2: 'SX',
//     iso3: 'SXM',
//     dialCode: '+1-721',
//     maxDigit: 7,
//     nddPrefix: '1',
//   },
//   {
//     name: {
//       en: 'Slovakia',
//       fr: 'Slovaquie',
//     },
//     iso2: 'SK',
//     iso3: 'SVK',
//     dialCode: '+421',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Slovenia',
//       fr: 'Slovénie',
//     },
//     iso2: 'SI',
//     iso3: 'SVN',
//     dialCode: '+386',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Solomon Islands',
//       fr: 'Îles Salomon',
//     },
//     iso2: 'SB',
//     iso3: 'SLB',
//     dialCode: '+677',
//     maxDigit: 7,
//     nddPrefix: '',
//   },
//   {
//     name: {
//       en: 'Somalia',
//       fr: 'Somalie',
//     },
//     iso2: 'SO',
//     iso3: 'SOM',
//     dialCode: '+252',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'South Africa',
//       fr: 'Afrique du Sud',
//     },
//     iso2: 'ZA',
//     iso3: 'ZAF',
//     dialCode: '+27',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'South Sudan',
//       fr: 'Soudan du Sud',
//     },
//     iso2: 'SS',
//     iso3: 'SSD',
//     dialCode: '+211',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Spain',
//       fr: 'Espagne',
//     },
//     iso2: 'ES',
//     iso3: 'ESP',
//     dialCode: '+34',
//     maxDigit: 9,
//     nddPrefix: '',
//   },
//   {
//     name: {
//       en: 'Sri Lanka',
//       fr: 'Sri Lanka',
//     },
//     iso2: 'LK',
//     iso3: 'LKA',
//     dialCode: '+94',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Sudan',
//       fr: 'Soudan',
//     },
//     iso2: 'SD',
//     iso3: 'SDN',
//     dialCode: '+249',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Suriname',
//       fr: 'Suriname',
//     },
//     iso2: 'SR',
//     iso3: 'SUR',
//     dialCode: '+597',
//     maxDigit: 7,
//     nddPrefix: '',
//   },
//   {
//     name: {
//       en: 'Svalbard and Jan Mayen',
//       fr: 'Svalbard et Jan Mayen',
//     },
//     iso2: 'SJ',
//     iso3: 'SJM',
//     dialCode: '+47',
//     maxDigit: 8,
//     nddPrefix: null,
//   },
//   {
//     name: {
//       en: 'Sweden',
//       fr: 'Suède',
//     },
//     iso2: 'SE',
//     iso3: 'SWE',
//     dialCode: '+46',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Switzerland',
//       fr: 'Suisse',
//     },
//     iso2: 'CH',
//     iso3: 'CHE',
//     dialCode: '+41',
//     maxDigit: 9,
//     nddPrefix: '',
//   },
//   {
//     name: {
//       en: 'Syria',
//       fr: 'Syrie',
//     },
//     iso2: 'SY',
//     iso3: 'SYR',
//     dialCode: '+963',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Taiwan',
//       fr: 'Taïwan',
//     },
//     iso2: 'TW',
//     iso3: 'TWN',
//     dialCode: '+886',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Tajikistan',
//       fr: 'Tadjikistan',
//     },
//     iso2: 'TJ',
//     iso3: 'TJK',
//     dialCode: '+992',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Tanzania',
//       fr: 'Tanzanie',
//     },
//     iso2: 'TZ',
//     iso3: 'TZA',
//     dialCode: '+255',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Thailand',
//       fr: 'Thaïlande',
//     },
//     iso2: 'TH',
//     iso3: 'THA',
//     dialCode: '+66',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Togo',
//       fr: 'Togo',
//     },
//     iso2: 'TG',
//     iso3: 'TGO',
//     dialCode: '+228',
//     maxDigit: 8,
//     nddPrefix: '',
//   },
//   {
//     name: {
//       en: 'Tokelau',
//       fr: 'Tokelau',
//     },
//     iso2: 'TK',
//     iso3: 'TKL',
//     dialCode: '+690',
//     maxDigit: 4,
//     nddPrefix: null,
//   },
//   {
//     name: {
//       en: 'Tonga',
//       fr: 'Tonga',
//     },
//     iso2: 'TO',
//     iso3: 'TON',
//     dialCode: '+676',
//     maxDigit: 7,
//     nddPrefix: '',
//   },
//   {
//     name: {
//       en: 'Trinidad and Tobago',
//       fr: 'Trinité-et-Tobago',
//     },
//     iso2: 'TT',
//     iso3: 'TTO',
//     dialCode: '+1-868',
//     maxDigit: 7,
//     nddPrefix: '',
//   },
//   {
//     name: {
//       en: 'Tunisia',
//       fr: 'Tunisie',
//     },
//     iso2: 'TN',
//     iso3: 'TUN',
//     dialCode: '+216',
//     maxDigit: 8,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Turkey',
//       fr: 'Turquie',
//     },
//     iso2: 'TR',
//     iso3: 'TUR',
//     dialCode: '+90',
//     maxDigit: 10,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Turkmenistan',
//       fr: 'Turkménistan',
//     },
//     iso2: 'TM',
//     iso3: 'TKM',
//     dialCode: '+993',
//     maxDigit: 8,
//     nddPrefix: '8',
//   },
//   {
//     name: {
//       en: 'Turks and Caicos Islands',
//       fr: 'Îles Turques-et-Caïques',
//     },
//     iso2: 'TC',
//     iso3: 'TCA',
//     dialCode: '+1-649',
//     maxDigit: 7,
//     nddPrefix: '1',
//   },
//   {
//     name: {
//       en: 'Tuvalu',
//       fr: 'Tuvalu',
//     },
//     iso2: 'TV',
//     iso3: 'TUV',
//     dialCode: '+688',
//     maxDigit: 7,
//     nddPrefix: '',
//   },
//   {
//     name: {
//       en: 'U.S. Virgin Islands',
//       fr: 'Îles Vierges des États-Unis',
//     },
//     iso2: 'VI',
//     iso3: 'VIR',
//     dialCode: '+1-340',
//     maxDigit: 7,
//     nddPrefix: '1',
//   },
//   {
//     name: {
//       en: 'Uganda',
//       fr: 'Ouganda',
//     },
//     iso2: 'UG',
//     iso3: 'UGA',
//     dialCode: '+256',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Ukraine',
//       fr: 'Ukraine',
//     },
//     iso2: 'UA',
//     iso3: 'UKR',
//     dialCode: '+380',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'United Arab Emirates',
//       fr: 'Émirats Arabes Unis',
//     },
//     iso2: 'AE',
//     iso3: 'ARE',
//     dialCode: '+971',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'United Kingdom',
//       fr: 'Royaume-Uni',
//     },
//     iso2: 'GB',
//     iso3: 'GBR',
//     dialCode: '+44',
//     maxDigit: 10,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'United States',
//       fr: 'États-Unis',
//     },
//     iso2: 'US',
//     iso3: 'USA',
//     dialCode: '+1',
//     maxDigit: 10,
//     nddPrefix: '1',
//   },
//   {
//     name: {
//       en: 'Uruguay',
//       fr: 'Uruguay',
//     },
//     iso2: 'UY',
//     iso3: 'URY',
//     dialCode: '+598',
//     maxDigit: 8,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Uzbekistan',
//       fr: 'Ouzbékistan',
//     },
//     iso2: 'UZ',
//     iso3: 'UZB',
//     dialCode: '+998',
//     maxDigit: 9,
//     nddPrefix: '8',
//   },
//   {
//     name: {
//       en: 'Vanuatu',
//       fr: 'Vanuatu',
//     },
//     iso2: 'VU',
//     iso3: 'VUT',
//     dialCode: '+678',
//     maxDigit: 7,
//     nddPrefix: '',
//   },
//   {
//     name: {
//       en: 'Vatican City',
//       fr: 'Cité du Vatican',
//     },
//     iso2: 'VA',
//     iso3: 'VAT',
//     dialCode: '+379',
//     maxDigit: 5,
//     nddPrefix: '',
//   },
//   {
//     name: {
//       en: 'Venezuela',
//       fr: 'Venezuela',
//     },
//     iso2: 'VE',
//     iso3: 'VEN',
//     dialCode: '+58',
//     maxDigit: 10,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Vietnam',
//       fr: 'Viêt Nam',
//     },
//     iso2: 'VN',
//     iso3: 'VNM',
//     dialCode: '+84',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Wallis and Futuna',
//       fr: 'Wallis-et-Futuna',
//     },
//     iso2: 'WF',
//     iso3: 'WLF',
//     dialCode: '+681',
//     maxDigit: 6,
//     nddPrefix: null,
//   },
//   {
//     name: {
//       en: 'Western Sahara',
//       fr: 'Sahara occidental',
//     },
//     iso2: 'EH',
//     iso3: 'ESH',
//     dialCode: '+212',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Yemen',
//       fr: 'Yémen',
//     },
//     iso2: 'YE',
//     iso3: 'YEM',
//     dialCode: '+967',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Zambia',
//       fr: 'Zambie',
//     },
//     iso2: 'ZM',
//     iso3: 'ZMB',
//     dialCode: '+260',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
//   {
//     name: {
//       en: 'Zimbabwe',
//       fr: 'Zimbabwe',
//     },
//     iso2: 'ZW',
//     iso3: 'ZWE',
//     dialCode: '+263',
//     maxDigit: 9,
//     nddPrefix: '0',
//   },
// ];

export const phoneDialCodeData = [
  {
    name: { en: 'Afghanistan', fr: 'Afghanistan', ar: 'أفغانستان' },
    iso2: 'AF',
    iso3: 'AFG',
    dialCode: '+93',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Albania', fr: 'Albanie', ar: 'ألبانيا' },
    iso2: 'AL',
    iso3: 'ALB',
    dialCode: '+355',
    maxDigit: 8,
    nddPrefix: '0',
  },
  {
    name: { en: 'Algeria', fr: 'Algérie', ar: 'الجزائر' },
    iso2: 'DZ',
    iso3: 'DZA',
    dialCode: '+213',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'American Samoa', fr: 'Samoa américaines', ar: 'ساموا الأمريكية' },
    iso2: 'AS',
    iso3: 'ASM',
    dialCode: '+1-684',
    maxDigit: 7,
    nddPrefix: '1',
  },
  {
    name: { en: 'Andorra', fr: 'Andorre', ar: 'أندورا' },
    iso2: 'AD',
    iso3: 'AND',
    dialCode: '+376',
    maxDigit: 6,
    nddPrefix: '0',
  },
  {
    name: { en: 'Angola', fr: 'Angola', ar: 'أنغولا' },
    iso2: 'AO',
    iso3: 'AGO',
    dialCode: '+244',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Anguilla', fr: 'Anguilla', ar: 'أنغويلا' },
    iso2: 'AI',
    iso3: 'AIA',
    dialCode: '+1-264',
    maxDigit: 7,
    nddPrefix: '1',
  },
  {
    name: { en: 'Antarctica', fr: 'Antarctique', ar: 'أنتاركتيكا' },
    iso2: 'AQ',
    iso3: 'ATA',
    dialCode: '+672',
    maxDigit: 10,
    nddPrefix: null,
  },
  {
    name: { en: 'Antigua and Barbuda', fr: 'Antigua-et-Barbuda', ar: 'أنتيغوا وبربودا' },
    iso2: 'AG',
    iso3: 'ATG',
    dialCode: '+1-268',
    maxDigit: 7,
    nddPrefix: '1',
  },
  {
    name: { en: 'Argentina', fr: 'Argentine', ar: 'الأرجنتين' },
    iso2: 'AR',
    iso3: 'ARG',
    dialCode: '+54',
    maxDigit: 10,
    nddPrefix: '0',
  },
  {
    name: { en: 'Armenia', fr: 'Arménie', ar: 'أرمينيا' },
    iso2: 'AM',
    iso3: 'ARM',
    dialCode: '+374',
    maxDigit: 8,
    nddPrefix: '0',
  },
  {
    name: { en: 'Aruba', fr: 'Aruba', ar: 'أروبا' },
    iso2: 'AW',
    iso3: 'ABW',
    dialCode: '+297',
    maxDigit: 7,
    nddPrefix: '0',
  },
  {
    name: { en: 'Australia', fr: 'Australie', ar: 'أستراليا' },
    iso2: 'AU',
    iso3: 'AUS',
    dialCode: '+61',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Austria', fr: 'Autriche', ar: 'النمسا' },
    iso2: 'AT',
    iso3: 'AUT',
    dialCode: '+43',
    maxDigit: 10,
    nddPrefix: '0',
  },
  {
    name: { en: 'Azerbaijan', fr: 'Azerbaïdjan', ar: 'أذربيجان' },
    iso2: 'AZ',
    iso3: 'AZE',
    dialCode: '+994',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Bahamas', fr: 'Bahamas', ar: 'جزر البهاما' },
    iso2: 'BS',
    iso3: 'BHS',
    dialCode: '+1-242',
    maxDigit: 7,
    nddPrefix: '1',
  },
  {
    name: { en: 'Bahrain', fr: 'Bahreïn', ar: 'البحرين' },
    iso2: 'BH',
    iso3: 'BHR',
    dialCode: '+973',
    maxDigit: 8,
    nddPrefix: '0',
  },
  {
    name: { en: 'Bangladesh', fr: 'Bangladesh', ar: 'بنغلاديش' },
    iso2: 'BD',
    iso3: 'BGD',
    dialCode: '+880',
    maxDigit: 10,
    nddPrefix: '0',
  },
  {
    name: { en: 'Barbados', fr: 'Barbade', ar: 'بربادوس' },
    iso2: 'BB',
    iso3: 'BRB',
    dialCode: '+1-246',
    maxDigit: 7,
    nddPrefix: '1',
  },
  {
    name: { en: 'Belarus', fr: 'Bélarus', ar: 'بيلاروسيا' },
    iso2: 'BY',
    iso3: 'BLR',
    dialCode: '+375',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Belgium', fr: 'Belgique', ar: 'بلجيكا' },
    iso2: 'BE',
    iso3: 'BEL',
    dialCode: '+32',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Belize', fr: 'Belize', ar: 'بليز' },
    iso2: 'BZ',
    iso3: 'BLZ',
    dialCode: '+501',
    maxDigit: 7,
    nddPrefix: '0',
  },
  {
    name: { en: 'Benin', fr: 'Bénin', ar: 'بنين' },
    iso2: 'BJ',
    iso3: 'BEN',
    dialCode: '+229',
    maxDigit: 8,
    nddPrefix: '0',
  },
  {
    name: { en: 'Bermuda', fr: 'Bermudes', ar: 'برمودا' },
    iso2: 'BM',
    iso3: 'BMU',
    dialCode: '+1-441',
    maxDigit: 7,
    nddPrefix: '1',
  },
  {
    name: { en: 'Bhutan', fr: 'Bhoutan', ar: 'بوتان' },
    iso2: 'BT',
    iso3: 'BTN',
    dialCode: '+975',
    maxDigit: 8,
    nddPrefix: '0',
  },
  {
    name: { en: 'Bolivia', fr: 'Bolivie', ar: 'بوليفيا' },
    iso2: 'BO',
    iso3: 'BOL',
    dialCode: '+591',
    maxDigit: 8,
    nddPrefix: '0',
  },
  {
    name: { en: 'Bosnia and Herzegovina', fr: 'Bosnie-Herzégovine', ar: 'البوسنة والهرسك' },
    iso2: 'BA',
    iso3: 'BIH',
    dialCode: '+387',
    maxDigit: 8,
    nddPrefix: '0',
  },
  {
    name: { en: 'Botswana', fr: 'Botswana', ar: 'بوتسوانا' },
    iso2: 'BW',
    iso3: 'BWA',
    dialCode: '+267',
    maxDigit: 8,
    nddPrefix: '0',
  },
  {
    name: { en: 'Brazil', fr: 'Brésil', ar: 'البرازيل' },
    iso2: 'BR',
    iso3: 'BRA',
    dialCode: '+55',
    maxDigit: 11,
    nddPrefix: '0',
  },
  {
    name: {
      en: 'British Indian Ocean Territory',
      fr: "Territoire britannique de l'océan Indien",
      ar: 'إقليم المحيط الهندي البريطاني',
    },
    iso2: 'IO',
    iso3: 'IOT',
    dialCode: '+246',
    maxDigit: 7,
    nddPrefix: null,
  },
  {
    name: {
      en: 'British Virgin Islands',
      fr: 'Îles Vierges britanniques',
      ar: 'جزر العذراء البريطانية',
    },
    iso2: 'VG',
    iso3: 'VGB',
    dialCode: '+1-284',
    maxDigit: 7,
    nddPrefix: '1',
  },
  {
    name: { en: 'Brunei', fr: 'Brunei', ar: 'بروناي' },
    iso2: 'BN',
    iso3: 'BRN',
    dialCode: '+673',
    maxDigit: 7,
    nddPrefix: '0',
  },
  {
    name: { en: 'Bulgaria', fr: 'Bulgarie', ar: 'بلغاريا' },
    iso2: 'BG',
    iso3: 'BGR',
    dialCode: '+359',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Burkina Faso', fr: 'Burkina Faso', ar: 'بوركينا فاسو' },
    iso2: 'BF',
    iso3: 'BFA',
    dialCode: '+226',
    maxDigit: 8,
    nddPrefix: '0',
  },
  {
    name: { en: 'Burundi', fr: 'Burundi', ar: 'بوروندي' },
    iso2: 'BI',
    iso3: 'BDI',
    dialCode: '+257',
    maxDigit: 8,
    nddPrefix: '0',
  },
  {
    name: { en: 'Cambodia', fr: 'Cambodge', ar: 'كمبوديا' },
    iso2: 'KH',
    iso3: 'KHM',
    dialCode: '+855',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Cameroon', fr: 'Cameroun', ar: 'الكاميرون' },
    iso2: 'CM',
    iso3: 'CMR',
    dialCode: '+237',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Canada', fr: 'Canada', ar: 'كندا' },
    iso2: 'CA',
    iso3: 'CAN',
    dialCode: '+1',
    maxDigit: 10,
    nddPrefix: '1',
  },
  {
    name: { en: 'Cape Verde', fr: 'Cap-Vert', ar: 'الرأس الأخضر' },
    iso2: 'CV',
    iso3: 'CPV',
    dialCode: '+238',
    maxDigit: 7,
    nddPrefix: '0',
  },
  {
    name: { en: 'Cayman Islands', fr: 'Îles Caïmans', ar: 'جزر كايمان' },
    iso2: 'KY',
    iso3: 'CYM',
    dialCode: '+1-345',
    maxDigit: 7,
    nddPrefix: '1',
  },
  {
    name: {
      en: 'Central African Republic',
      fr: 'République Centrafricaine',
      ar: 'جمهورية أفريقيا الوسطى',
    },
    iso2: 'CF',
    iso3: 'CAF',
    dialCode: '+236',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Chad', fr: 'Tchad', ar: 'تشاد' },
    iso2: 'TD',
    iso3: 'TCD',
    dialCode: '+235',
    maxDigit: 8,
    nddPrefix: '0',
  },
  {
    name: { en: 'Chile', fr: 'Chili', ar: 'تشيلي' },
    iso2: 'CL',
    iso3: 'CHL',
    dialCode: '+56',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'China', fr: 'Chine', ar: 'الصين' },
    iso2: 'CN',
    iso3: 'CHN',
    dialCode: '+86',
    maxDigit: 11,
    nddPrefix: '0',
  },
  {
    name: { en: 'Christmas Island', fr: 'Île Christmas', ar: 'جزيرة الكريسماس' },
    iso2: 'CX',
    iso3: 'CXR',
    dialCode: '+61',
    maxDigit: 8,
    nddPrefix: '0',
  },
  {
    name: { en: 'Cocos (Keeling) Islands', fr: 'Îles Cocos (Keeling)', ar: 'جزر كوكوس' },
    iso2: 'CC',
    iso3: 'CCK',
    dialCode: '+61',
    maxDigit: 8,
    nddPrefix: '0',
  },
  {
    name: { en: 'Colombia', fr: 'Colombie', ar: 'كولومبيا' },
    iso2: 'CO',
    iso3: 'COL',
    dialCode: '+57',
    maxDigit: 10,
    nddPrefix: '0',
  },
  {
    name: { en: 'Comoros', fr: 'Comores', ar: 'جزر القمر' },
    iso2: 'KM',
    iso3: 'COM',
    dialCode: '+269',
    maxDigit: 7,
    nddPrefix: '0',
  },
  {
    name: { en: 'Cook Islands', fr: 'Îles Cook', ar: 'جزر كوك' },
    iso2: 'CK',
    iso3: 'COK',
    dialCode: '+682',
    maxDigit: 5,
    nddPrefix: null,
  },
  {
    name: {
      en: 'Congo (Congo-Brazzaville)',
      fr: 'Congo (Congo-Brazzaville)',
      ar: 'الكونغو برازافيل',
    },
    iso2: 'CG',
    iso3: 'COG',
    dialCode: '+242',
    maxDigit: 8,
    nddPrefix: '0',
  },
  {
    name: {
      en: 'Congo (Democratic Republic)',
      fr: 'Congo (République Démocratique)',
      ar: 'جمهورية الكونغو الديمقراطية',
    },
    iso2: 'CD',
    iso3: 'COD',
    dialCode: '+243',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Costa Rica', fr: 'Costa Rica', ar: 'كوستاريكا' },
    iso2: 'CR',
    iso3: 'CRI',
    dialCode: '+506',
    maxDigit: 8,
    nddPrefix: '0',
  },
  {
    name: {
      en: "Cote d'Ivoire (Ivory Coast)",
      fr: "Côte d'Ivoire (Côte d'Ivoire)",
      ar: 'ساحل العاج',
    },
    iso2: 'CI',
    iso3: 'CIV',
    dialCode: '+225',
    maxDigit: 8,
    nddPrefix: '',
  },
  {
    name: { en: 'Croatia', fr: 'Croatie', ar: 'كرواتيا' },
    iso2: 'HR',
    iso3: 'HRV',
    dialCode: '+385',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Cuba', fr: 'Cuba', ar: 'كوبا' },
    iso2: 'CU',
    iso3: 'CUB',
    dialCode: '+53',
    maxDigit: 8,
    nddPrefix: '0',
  },
  {
    name: { en: 'Curaçao', fr: 'Curaçao', ar: 'كوراساو' },
    iso2: 'CW',
    iso3: 'CUW',
    dialCode: '+599',
    maxDigit: 7,
    nddPrefix: null,
  },
  {
    name: { en: 'Cyprus', fr: 'Chypre', ar: 'قبرص' },
    iso2: 'CY',
    iso3: 'CYP',
    dialCode: '+357',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Czech Republic', fr: 'République tchèque', ar: 'جمهورية التشيك' },
    iso2: 'CZ',
    iso3: 'CZE',
    dialCode: '+420',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Denmark', fr: 'Danemark', ar: 'الدنمارك' },
    iso2: 'DK',
    iso3: 'DNK',
    dialCode: '+45',
    maxDigit: 8,
    nddPrefix: '0',
  },
  {
    name: { en: 'Djibouti', fr: 'Djibouti', ar: 'جيبوتي' },
    iso2: 'DJ',
    iso3: 'DJI',
    dialCode: '+253',
    maxDigit: 8,
    nddPrefix: '0',
  },
  {
    name: { en: 'Dominica', fr: 'Dominique', ar: 'دومينيكا' },
    iso2: 'DM',
    iso3: 'DMA',
    dialCode: '+1-767',
    maxDigit: 7,
    nddPrefix: '1',
  },
  {
    name: { en: 'Dominican Republic', fr: 'République Dominicaine', ar: 'جمهورية الدومينيكان' },
    iso2: 'DO',
    iso3: 'DOM',
    dialCode: '+1-809',
    maxDigit: 10,
    nddPrefix: '1',
  },
  {
    name: {
      en: 'East Timor(Timor-Leste)',
      fr: 'Timor oriental (Timor-Leste)',
      ar: 'تيمور الشرقية',
    },
    iso2: 'TL',
    iso3: 'TLS',
    dialCode: '+670',
    maxDigit: 8,
    nddPrefix: '0',
  },
  {
    name: { en: 'Ecuador', fr: 'Équateur', ar: 'الإكوادور' },
    iso2: 'EC',
    iso3: 'ECU',
    dialCode: '+593',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Egypt', fr: 'Égypte', ar: 'مصر' },
    iso2: 'EG',
    iso3: 'EGY',
    dialCode: '+20',
    maxDigit: 10,
    nddPrefix: '0',
  },
  {
    name: { en: 'El Salvador', fr: 'Salvador', ar: 'السلفادور' },
    iso2: 'SV',
    iso3: 'SLV',
    dialCode: '+503',
    maxDigit: 8,
    nddPrefix: '0',
  },
  {
    name: { en: 'Equatorial Guinea', fr: 'Guinée équatoriale', ar: 'غينيا الاستوائية' },
    iso2: 'GQ',
    iso3: 'GNQ',
    dialCode: '+240',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Eritrea', fr: 'Érythrée', ar: 'إريتريا' },
    iso2: 'ER',
    iso3: 'ERI',
    dialCode: '+291',
    maxDigit: 7,
    nddPrefix: '0',
  },
  {
    name: { en: 'Estonia', fr: 'Estonie', ar: 'إستونيا' },
    iso2: 'EE',
    iso3: 'EST',
    dialCode: '+372',
    maxDigit: 8,
    nddPrefix: '0',
  },
  {
    name: { en: 'Ethiopia', fr: 'Éthiopie', ar: 'إثيوبيا' },
    iso2: 'ET',
    iso3: 'ETH',
    dialCode: '+251',
    maxDigit: 10,
    nddPrefix: '0',
  },
  {
    name: { en: 'Falkland Islands', fr: 'Îles Malouines', ar: 'جزر فوكلاند' },
    iso2: 'FK',
    iso3: 'FLK',
    dialCode: '+500',
    maxDigit: 5,
    nddPrefix: null,
  },
  {
    name: { en: 'Faroe Islands', fr: 'Îles Féroé', ar: 'جزر فارو' },
    iso2: 'FO',
    iso3: 'FRO',
    dialCode: '+298',
    maxDigit: 6,
    nddPrefix: null,
  },
  {
    name: { en: 'Fiji', fr: 'Fidji', ar: 'فيجي' },
    iso2: 'FJ',
    iso3: 'FJI',
    dialCode: '+679',
    maxDigit: 8,
    nddPrefix: '0',
  },
  {
    name: { en: 'Finland', fr: 'Finlande', ar: 'فنلندا' },
    iso2: 'FI',
    iso3: 'FIN',
    dialCode: '+358',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'France', fr: 'France', ar: 'فرنسا' },
    iso2: 'FR',
    iso3: 'FRA',
    dialCode: '+33',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'French Polynesia', fr: 'Polynésie française', ar: 'بولينيزيا الفرنسية' },
    iso2: 'PF',
    iso3: 'PYF',
    dialCode: '+689',
    maxDigit: 8,
    nddPrefix: null,
  },
  {
    name: { en: 'Eswatini (Swaziland)', fr: 'Eswatini (Swaziland)', ar: 'إسواتيني' },
    iso2: 'SZ',
    iso3: 'SWZ',
    dialCode: '+268',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Gabon', fr: 'Gabon', ar: 'الغابون' },
    iso2: 'GA',
    iso3: 'GAB',
    dialCode: '+241',
    maxDigit: 8,
    nddPrefix: '0',
  },
  {
    name: { en: 'Gambia', fr: 'Gambie', ar: 'غامبيا' },
    iso2: 'GM',
    iso3: 'GMB',
    dialCode: '+220',
    maxDigit: 7,
    nddPrefix: '0',
  },
  {
    name: { en: 'Georgia', fr: 'Géorgie', ar: 'جورجيا' },
    iso2: 'GE',
    iso3: 'GEO',
    dialCode: '+995',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Germany', fr: 'Allemagne', ar: 'ألمانيا' },
    iso2: 'DE',
    iso3: 'DEU',
    dialCode: '+49',
    maxDigit: 11,
    nddPrefix: '0',
  },
  {
    name: { en: 'Ghana', fr: 'Ghana', ar: 'غانا' },
    iso2: 'GH',
    iso3: 'GHA',
    dialCode: '+233',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Gibraltar', fr: 'Gibraltar', ar: 'جبل طارق' },
    iso2: 'GI',
    iso3: 'GIB',
    dialCode: '+350',
    maxDigit: 8,
    nddPrefix: null,
  },
  {
    name: { en: 'Greece', fr: 'Grèce', ar: 'اليونان' },
    iso2: 'GR',
    iso3: 'GRC',
    dialCode: '+30',
    maxDigit: 10,
    nddPrefix: '0',
  },
  {
    name: { en: 'Greenland', fr: 'Groenland', ar: 'جرينلاند' },
    iso2: 'GL',
    iso3: 'GRL',
    dialCode: '+299',
    maxDigit: 6,
    nddPrefix: null,
  },
  {
    name: { en: 'Grenada', fr: 'Grenade', ar: 'غرينادا' },
    iso2: 'GD',
    iso3: 'GRD',
    dialCode: '+1-473',
    maxDigit: 7,
    nddPrefix: '1',
  },
  {
    name: { en: 'Guam', fr: 'Guam', ar: 'غوام' },
    iso2: 'GU',
    iso3: 'GUM',
    dialCode: '+1-671',
    maxDigit: 7,
    nddPrefix: '1',
  },
  {
    name: { en: 'Guatemala', fr: 'Guatemala', ar: 'غواتيمالا' },
    iso2: 'GT',
    iso3: 'GTM',
    dialCode: '+502',
    maxDigit: 8,
    nddPrefix: '0',
  },
  {
    name: { en: 'Guernsey', fr: 'Guernesey', ar: 'غيرنزي' },
    iso2: 'GG',
    iso3: 'GGY',
    dialCode: '+44-1481',
    maxDigit: 6,
    nddPrefix: '0',
  },
  {
    name: { en: 'Guinea', fr: 'Guinée', ar: 'غينيا' },
    iso2: 'GN',
    iso3: 'GIN',
    dialCode: '+224',
    maxDigit: 8,
    nddPrefix: '0',
  },
  {
    name: { en: 'Guinea-Bissau', fr: 'Guinée-Bissau', ar: 'غينيا بيساو' },
    iso2: 'GW',
    iso3: 'GNB',
    dialCode: '+245',
    maxDigit: 7,
    nddPrefix: '0',
  },
  {
    name: { en: 'Guyana', fr: 'Guyane', ar: 'غيانا' },
    iso2: 'GY',
    iso3: 'GUY',
    dialCode: '+592',
    maxDigit: 7,
    nddPrefix: '0',
  },
  {
    name: { en: 'Haiti', fr: 'Haïti', ar: 'هايتي' },
    iso2: 'HT',
    iso3: 'HTI',
    dialCode: '+509',
    maxDigit: 8,
    nddPrefix: '0',
  },
  {
    name: { en: 'Honduras', fr: 'Honduras', ar: 'هندوراس' },
    iso2: 'HN',
    iso3: 'HND',
    dialCode: '+504',
    maxDigit: 8,
    nddPrefix: '0',
  },
  {
    name: { en: 'Hong Kong', fr: 'Hong Kong', ar: 'هونغ كونغ' },
    iso2: 'HK',
    iso3: 'HKG',
    dialCode: '+852',
    maxDigit: 8,
    nddPrefix: '',
  },
  {
    name: { en: 'Hungary', fr: 'Hongrie', ar: 'المجر' },
    iso2: 'HU',
    iso3: 'HUN',
    dialCode: '+36',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Iceland', fr: 'Islande', ar: 'أيسلندا' },
    iso2: 'IS',
    iso3: 'ISL',
    dialCode: '+354',
    maxDigit: 7,
    nddPrefix: '0',
  },
  {
    name: { en: 'India', fr: 'Inde', ar: 'الهند' },
    iso2: 'IN',
    iso3: 'IND',
    dialCode: '+91',
    maxDigit: 10,
    nddPrefix: '0',
  },
  {
    name: { en: 'Indonesia', fr: 'Indonésie', ar: 'إندونيسيا' },
    iso2: 'ID',
    iso3: 'IDN',
    dialCode: '+62',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Iran', fr: 'Iran', ar: 'إيران' },
    iso2: 'IR',
    iso3: 'IRN',
    dialCode: '+98',
    maxDigit: 10,
    nddPrefix: '0',
  },
  {
    name: { en: 'Iraq', fr: 'Irak', ar: 'العراق' },
    iso2: 'IQ',
    iso3: 'IRQ',
    dialCode: '+964',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Ireland', fr: 'Irlande', ar: 'أيرلندا' },
    iso2: 'IE',
    iso3: 'IRL',
    dialCode: '+353',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Isle of Man', fr: 'Île de Man', ar: 'جزيرة مان' },
    iso2: 'IM',
    iso3: 'IMN',
    dialCode: '+44-1624',
    maxDigit: 6,
    nddPrefix: '0',
  },
  {
    name: { en: 'Israel', fr: 'Israël', ar: 'إسرائيل' },
    iso2: 'IL',
    iso3: 'ISR',
    dialCode: '+972',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Italy', fr: 'Italie', ar: 'إيطاليا' },
    iso2: 'IT',
    iso3: 'ITA',
    dialCode: '+39',
    maxDigit: 10,
    nddPrefix: '0',
  },
  {
    name: { en: 'Jamaica', fr: 'Jamaïque', ar: 'جامايكا' },
    iso2: 'JM',
    iso3: 'JAM',
    dialCode: '+1-876',
    maxDigit: 7,
    nddPrefix: '1',
  },
  {
    name: { en: 'Japan', fr: 'Japon', ar: 'اليابان' },
    iso2: 'JP',
    iso3: 'JPN',
    dialCode: '+81',
    maxDigit: 10,
    nddPrefix: '0',
  },
  {
    name: { en: 'Jersey', fr: 'Jersey', ar: 'جيرسي' },
    iso2: 'JE',
    iso3: 'JEY',
    dialCode: '+44-1534',
    maxDigit: 10,
    nddPrefix: '0',
  },
  {
    name: { en: 'Jordan', fr: 'Jordanie', ar: 'الأردن' },
    iso2: 'JO',
    iso3: 'JOR',
    dialCode: '+962',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Kazakhstan', fr: 'Kazakhstan', ar: 'كازاخستان' },
    iso2: 'KZ',
    iso3: 'KAZ',
    dialCode: '+7',
    maxDigit: 10,
    nddPrefix: '0',
  },
  {
    name: { en: 'Kenya', fr: 'Kenya', ar: 'كينيا' },
    iso2: 'KE',
    iso3: 'KEN',
    dialCode: '+254',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Kiribati', fr: 'Kiribati', ar: 'كيريباتي' },
    iso2: 'KI',
    iso3: 'KIR',
    dialCode: '+686',
    maxDigit: 7,
    nddPrefix: '0',
  },
  {
    name: { en: 'Kosovo', fr: 'Kosovo', ar: 'كوسوفو' },
    iso2: 'XK',
    iso3: 'XKX',
    dialCode: '+383',
    maxDigit: 8,
    nddPrefix: null,
  },
  {
    name: { en: 'Korea (North)', fr: 'Corée du Nord', ar: 'كوريا الشمالية' },
    iso2: 'KP',
    iso3: 'PRK',
    dialCode: '+850',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Korea (South)', fr: 'Corée du Sud', ar: 'كوريا الجنوبية' },
    iso2: 'KR',
    iso3: 'KOR',
    dialCode: '+82',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Kuwait', fr: 'Koweït', ar: 'الكويت' },
    iso2: 'KW',
    iso3: 'KWT',
    dialCode: '+965',
    maxDigit: 8,
    nddPrefix: '0',
  },
  {
    name: { en: 'Kyrgyzstan', fr: 'Kirghizistan', ar: 'قيرغيزستان' },
    iso2: 'KG',
    iso3: 'KGZ',
    dialCode: '+996',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Laos', fr: 'Laos', ar: 'لاوس' },
    iso2: 'LA',
    iso3: 'LAO',
    dialCode: '+856',
    maxDigit: 8,
    nddPrefix: '0',
  },
  {
    name: { en: 'Latvia', fr: 'Lettonie', ar: 'لاتفيا' },
    iso2: 'LV',
    iso3: 'LVA',
    dialCode: '+371',
    maxDigit: 8,
    nddPrefix: '0',
  },
  {
    name: { en: 'Lebanon', fr: 'Liban', ar: 'لبنان' },
    iso2: 'LB',
    iso3: 'LBN',
    dialCode: '+961',
    maxDigit: 8,
    nddPrefix: '0',
  },
  {
    name: { en: 'Lesotho', fr: 'Lesotho', ar: 'ليسوتو' },
    iso2: 'LS',
    iso3: 'LSO',
    dialCode: '+266',
    maxDigit: 8,
    nddPrefix: '0',
  },
  {
    name: { en: 'Liberia', fr: 'Liberia', ar: 'ليبيريا' },
    iso2: 'LR',
    iso3: 'LBR',
    dialCode: '+231',
    maxDigit: 8,
    nddPrefix: '0',
  },
  {
    name: { en: 'Libya', fr: 'Libye', ar: 'ليبيا' },
    iso2: 'LY',
    iso3: 'LBY',
    dialCode: '+218',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Liechtenstein', fr: 'Liechtenstein', ar: 'ليختنشتاين' },
    iso2: 'LI',
    iso3: 'LIE',
    dialCode: '+423',
    maxDigit: 8,
    nddPrefix: '0',
  },
  {
    name: { en: 'Lithuania', fr: 'Lituanie', ar: 'ليتوانيا' },
    iso2: 'LT',
    iso3: 'LTU',
    dialCode: '+370',
    maxDigit: 8,
    nddPrefix: '0',
  },
  {
    name: { en: 'Luxembourg', fr: 'Luxembourg', ar: 'لوكسمبورغ' },
    iso2: 'LU',
    iso3: 'LUX',
    dialCode: '+352',
    maxDigit: 8,
    nddPrefix: '0',
  },
  {
    name: { en: 'Macao (SAR China)', fr: 'Macao (RAS Chine)', ar: 'ماكاو' },
    iso2: 'MO',
    iso3: 'MAC',
    dialCode: '+853',
    maxDigit: 8,
    nddPrefix: null,
  },
  {
    name: { en: 'Madagascar', fr: 'Madagascar', ar: 'مدغشقر' },
    iso2: 'MG',
    iso3: 'MDG',
    dialCode: '+261',
    maxDigit: 8,
    nddPrefix: '0',
  },
  {
    name: { en: 'Malawi', fr: 'Malawi', ar: 'ملاوي' },
    iso2: 'MW',
    iso3: 'MWI',
    dialCode: '+265',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Malaysia', fr: 'Malaisie', ar: 'ماليزيا' },
    iso2: 'MY',
    iso3: 'MYS',
    dialCode: '+60',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Maldives', fr: 'Maldives', ar: 'جزر المالديف' },
    iso2: 'MV',
    iso3: 'MDV',
    dialCode: '+960',
    maxDigit: 7,
    nddPrefix: '0',
  },
  {
    name: { en: 'Mali', fr: 'Mali', ar: 'مالي' },
    iso2: 'ML',
    iso3: 'MLI',
    dialCode: '+223',
    maxDigit: 8,
    nddPrefix: '0',
  },
  {
    name: { en: 'Malta', fr: 'Malte', ar: 'مالطا' },
    iso2: 'MT',
    iso3: 'MLT',
    dialCode: '+356',
    maxDigit: 8,
    nddPrefix: '0',
  },
  {
    name: { en: 'Marshall Islands', fr: 'Îles Marshall', ar: 'جزر مارشال' },
    iso2: 'MH',
    iso3: 'MHL',
    dialCode: '+692',
    maxDigit: 7,
    nddPrefix: '0',
  },
  {
    name: { en: 'Mauritania', fr: 'Mauritanie', ar: 'موريتانيا' },
    iso2: 'MR',
    iso3: 'MRT',
    dialCode: '+222',
    maxDigit: 8,
    nddPrefix: '0',
  },
  {
    name: { en: 'Mauritius', fr: 'Île Maurice', ar: 'موريشيوس' },
    iso2: 'MU',
    iso3: 'MUS',
    dialCode: '+230',
    maxDigit: 8,
    nddPrefix: '0',
  },
  {
    name: { en: 'Mayotte', fr: 'Mayotte', ar: 'مايوت' },
    iso2: 'YT',
    iso3: 'MYT',
    dialCode: '+262',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Mexico', fr: 'Mexique', ar: 'المكسيك' },
    iso2: 'MX',
    iso3: 'MEX',
    dialCode: '+52',
    maxDigit: 10,
    nddPrefix: '0',
  },
  {
    name: { en: 'Micronesia', fr: 'Micronésie', ar: 'ميكرونيزيا' },
    iso2: 'FM',
    iso3: 'FSM',
    dialCode: '+691',
    maxDigit: 7,
    nddPrefix: '0',
  },
  {
    name: { en: 'Moldova', fr: 'Moldavie', ar: 'مولدوفا' },
    iso2: 'MD',
    iso3: 'MDA',
    dialCode: '+373',
    maxDigit: 8,
    nddPrefix: '0',
  },
  {
    name: { en: 'Monaco', fr: 'Monaco', ar: 'موناكو' },
    iso2: 'MC',
    iso3: 'MCO',
    dialCode: '+377',
    maxDigit: 8,
    nddPrefix: '0',
  },
  {
    name: { en: 'Mongolia', fr: 'Mongolie', ar: 'منغوليا' },
    iso2: 'MN',
    iso3: 'MNG',
    dialCode: '+976',
    maxDigit: 8,
    nddPrefix: '0',
  },
  {
    name: { en: 'Montenegro', fr: 'Monténégro', ar: 'الجبل الأسود' },
    iso2: 'ME',
    iso3: 'MNE',
    dialCode: '+382',
    maxDigit: 8,
    nddPrefix: '0',
  },
  {
    name: { en: 'Montserrat', fr: 'Montserrat', ar: 'مونتسرات' },
    iso2: 'MS',
    iso3: 'MSR',
    dialCode: '+1-664',
    maxDigit: 7,
    nddPrefix: '1',
  },
  {
    name: { en: 'Morocco', fr: 'Maroc', ar: 'المغرب' },
    iso2: 'MA',
    iso3: 'MAR',
    dialCode: '+212',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Mozambique', fr: 'Mozambique', ar: 'موزمبيق' },
    iso2: 'MZ',
    iso3: 'MOZ',
    dialCode: '+258',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Myanmar', fr: 'Birmanie', ar: 'ميانمار' },
    iso2: 'MM',
    iso3: 'MMR',
    dialCode: '+95',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Namibia', fr: 'Namibie', ar: 'ناميبيا' },
    iso2: 'NA',
    iso3: 'NAM',
    dialCode: '+264',
    maxDigit: 8,
    nddPrefix: '0',
  },
  {
    name: { en: 'Nauru', fr: 'Nauru', ar: 'ناورو' },
    iso2: 'NR',
    iso3: 'NRU',
    dialCode: '+674',
    maxDigit: 7,
    nddPrefix: '0',
  },
  {
    name: { en: 'Nepal', fr: 'Népal', ar: 'نيبال' },
    iso2: 'NP',
    iso3: 'NPL',
    dialCode: '+977',
    maxDigit: 10,
    nddPrefix: '0',
  },
  {
    name: { en: 'Netherlands', fr: 'Pays-Bas', ar: 'هولندا' },
    iso2: 'NL',
    iso3: 'NLD',
    dialCode: '+31',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Netherlands Antilles', fr: 'Antilles néerlandaises', ar: 'جزر الأنتيل الهولندية' },
    iso2: 'AN',
    iso3: 'ANT',
    dialCode: '+599',
    maxDigit: 7,
    nddPrefix: null,
  },
  {
    name: { en: 'New Caledonia', fr: 'Nouvelle-Calédonie', ar: 'كاليدونيا الجديدة' },
    iso2: 'NC',
    iso3: 'NCL',
    dialCode: '+687',
    maxDigit: 6,
    nddPrefix: null,
  },
  {
    name: { en: 'New Zealand', fr: 'Nouvelle-Zélande', ar: 'نيوزيلندا' },
    iso2: 'NZ',
    iso3: 'NZL',
    dialCode: '+64',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Nicaragua', fr: 'Nicaragua', ar: 'نيكاراغوا' },
    iso2: 'NI',
    iso3: 'NIC',
    dialCode: '+505',
    maxDigit: 8,
    nddPrefix: '0',
  },
  {
    name: { en: 'Niger', fr: 'Niger', ar: 'النيجر' },
    iso2: 'NE',
    iso3: 'NER',
    dialCode: '+227',
    maxDigit: 8,
    nddPrefix: '0',
  },
  {
    name: { en: 'Nigeria', fr: 'Nigeria', ar: 'نيجيريا' },
    iso2: 'NG',
    iso3: 'NGA',
    dialCode: '+234',
    maxDigit: 10,
    nddPrefix: '0',
  },
  {
    name: { en: 'Niue', fr: 'Niue', ar: 'نيوي' },
    iso2: 'NU',
    iso3: 'NIU',
    dialCode: '+683',
    maxDigit: 4,
    nddPrefix: '',
  },
  {
    name: {
      en: 'Northern Mariana Islands',
      fr: 'Îles Mariannes du Nord',
      ar: 'جزر ماريانا الشمالية',
    },
    iso2: 'MP',
    iso3: 'MNP',
    dialCode: '+1-670',
    maxDigit: 7,
    nddPrefix: '1',
  },
  {
    name: { en: 'North Macedonia', fr: 'Macédoine du Nord', ar: 'مقدونيا الشمالية' },
    iso2: 'MK',
    iso3: 'MKD',
    dialCode: '+389',
    maxDigit: 8,
    nddPrefix: '0',
  },
  {
    name: { en: 'Norway', fr: 'Norvège', ar: 'النرويج' },
    iso2: 'NO',
    iso3: 'NOR',
    dialCode: '+47',
    maxDigit: 8,
    nddPrefix: '0',
  },
  {
    name: { en: 'Oman', fr: 'Oman', ar: 'عمان' },
    iso2: 'OM',
    iso3: 'OMN',
    dialCode: '+968',
    maxDigit: 8,
    nddPrefix: '0',
  },
  {
    name: { en: 'Pakistan', fr: 'Pakistan', ar: 'باكستان' },
    iso2: 'PK',
    iso3: 'PAK',
    dialCode: '+92',
    maxDigit: 10,
    nddPrefix: '0',
  },
  {
    name: { en: 'Palau', fr: 'Palaos', ar: 'بالاو' },
    iso2: 'PW',
    iso3: 'PLW',
    dialCode: '+680',
    maxDigit: 7,
    nddPrefix: '',
  },
  {
    name: { en: 'Palestine', fr: 'Palestine', ar: 'فلسطين' },
    iso2: 'PS',
    iso3: 'PSE',
    dialCode: '+970',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Panama', fr: 'Panama', ar: 'بنما' },
    iso2: 'PA',
    iso3: 'PAN',
    dialCode: '+507',
    maxDigit: 8,
    nddPrefix: '',
  },
  {
    name: { en: 'Papua New Guinea', fr: 'Papouasie-Nouvelle-Guinée', ar: 'بابوا غينيا الجديدة' },
    iso2: 'PG',
    iso3: 'PNG',
    dialCode: '+675',
    maxDigit: 8,
    nddPrefix: '',
  },
  {
    name: { en: 'Paraguay', fr: 'Paraguay', ar: 'باراغواي' },
    iso2: 'PY',
    iso3: 'PRY',
    dialCode: '+595',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Peru', fr: 'Pérou', ar: 'بيرو' },
    iso2: 'PE',
    iso3: 'PER',
    dialCode: '+51',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Philippines', fr: 'Philippines', ar: 'الفلبين' },
    iso2: 'PH',
    iso3: 'PHL',
    dialCode: '+63',
    maxDigit: 10,
    nddPrefix: '0',
  },
  {
    name: { en: 'Pitcairn Islands', fr: 'Îles Pitcairn', ar: 'جزر بيتكيرن' },
    iso2: 'PN',
    iso3: 'PCN',
    dialCode: '+64',
    maxDigit: 5,
    nddPrefix: '0',
  },
  {
    name: { en: 'Poland', fr: 'Pologne', ar: 'بولندا' },
    iso2: 'PL',
    iso3: 'POL',
    dialCode: '+48',
    maxDigit: 9,
    nddPrefix: '',
  },
  {
    name: { en: 'Portugal', fr: 'Portugal', ar: 'البرتغال' },
    iso2: 'PT',
    iso3: 'PRT',
    dialCode: '+351',
    maxDigit: 9,
    nddPrefix: '',
  },
  {
    name: { en: 'Puerto Rico', fr: 'Porto Rico', ar: 'بورتوريكو' },
    iso2: 'PR',
    iso3: 'PRI',
    dialCode: '+1-787',
    maxDigit: 7,
    nddPrefix: '1',
  },
  {
    name: { en: 'Qatar', fr: 'Qatar', ar: 'قطر' },
    iso2: 'QA',
    iso3: 'QAT',
    dialCode: '+974',
    maxDigit: 8,
    nddPrefix: '',
  },
  {
    name: { en: 'Reunion', fr: 'La Réunion', ar: 'لا ريونيون' },
    iso2: 'RE',
    iso3: 'REU',
    dialCode: '+262',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Romania', fr: 'Roumanie', ar: 'رومانيا' },
    iso2: 'RO',
    iso3: 'ROU',
    dialCode: '+40',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Russia', fr: 'Russie', ar: 'روسيا' },
    iso2: 'RU',
    iso3: 'RUS',
    dialCode: '+7',
    maxDigit: 10,
    nddPrefix: '8',
  },
  {
    name: { en: 'Rwanda', fr: 'Rwanda', ar: 'رواندا' },
    iso2: 'RW',
    iso3: 'RWA',
    dialCode: '+250',
    maxDigit: 9,
    nddPrefix: '',
  },
  {
    name: { en: 'Saint Barthelemy', fr: 'Saint-Barthélemy', ar: 'سان بارتيليمي' },
    iso2: 'BL',
    iso3: 'BLM',
    dialCode: '+590',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Saint Helena', fr: 'Sainte-Hélène', ar: 'سانت هيلينا' },
    iso2: 'SH',
    iso3: 'SHN',
    dialCode: '+290',
    maxDigit: 4,
    nddPrefix: null,
  },
  {
    name: { en: 'Saint Kitts and Nevis', fr: 'Saint-Christophe-et-Niévès', ar: 'سانت كيتس ونيفيس' },
    iso2: 'KN',
    iso3: 'KNA',
    dialCode: '+1-869',
    maxDigit: 7,
    nddPrefix: '',
  },
  {
    name: { en: 'Saint Lucia', fr: 'Sainte-Lucie', ar: 'سانت لوسيا' },
    iso2: 'LC',
    iso3: 'LCA',
    dialCode: '+1-758',
    maxDigit: 7,
    nddPrefix: '',
  },
  {
    name: { en: 'Saint Martin', fr: 'Saint-Martin', ar: 'سان مارتن' },
    iso2: 'MF',
    iso3: 'MAF',
    dialCode: '+590',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: {
      en: 'Saint Pierre and Miquelon',
      fr: 'Saint-Pierre-et-Miquelon',
      ar: 'سان بيير وميكلون',
    },
    iso2: 'PM',
    iso3: 'SPM',
    dialCode: '+508',
    maxDigit: 6,
    nddPrefix: null,
  },
  {
    name: {
      en: 'Saint Vincent and the Grenadines',
      fr: 'Saint-Vincent-et-les-Grenadines',
      ar: 'سانت فنسنت والغرينادين',
    },
    iso2: 'VC',
    iso3: 'VCT',
    dialCode: '+1-784',
    maxDigit: 7,
    nddPrefix: '',
  },
  {
    name: { en: 'Samoa', fr: 'Samoa', ar: 'ساموا' },
    iso2: 'WS',
    iso3: 'WSM',
    dialCode: '+685',
    maxDigit: 7,
    nddPrefix: '',
  },
  {
    name: { en: 'San Marino', fr: 'Saint-Marin', ar: 'سان مارينو' },
    iso2: 'SM',
    iso3: 'SMR',
    dialCode: '+378',
    maxDigit: 10,
    nddPrefix: '',
  },
  {
    name: { en: 'Sao Tome and Principe', fr: 'Sao Tomé-et-Principe', ar: 'ساو تومي وبرينسيبي' },
    iso2: 'ST',
    iso3: 'STP',
    dialCode: '+239',
    maxDigit: 7,
    nddPrefix: '',
  },
  {
    name: { en: 'Saudi Arabia', fr: 'Arabie Saoudite', ar: 'المملكة العربية السعودية' },
    iso2: 'SA',
    iso3: 'SAU',
    dialCode: '+966',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Senegal', fr: 'Sénégal', ar: 'السنغال' },
    iso2: 'SN',
    iso3: 'SEN',
    dialCode: '+221',
    maxDigit: 9,
    nddPrefix: '',
  },
  {
    name: { en: 'Serbia', fr: 'Serbie', ar: 'صربيا' },
    iso2: 'RS',
    iso3: 'SRB',
    dialCode: '+381',
    maxDigit: 10,
    nddPrefix: '0',
  },
  {
    name: { en: 'Seychelles', fr: 'Seychelles', ar: 'سيشل' },
    iso2: 'SC',
    iso3: 'SYC',
    dialCode: '+248',
    maxDigit: 7,
    nddPrefix: '',
  },
  {
    name: { en: 'Sierra Leone', fr: 'Sierra Leone', ar: 'سيراليون' },
    iso2: 'SL',
    iso3: 'SLE',
    dialCode: '+232',
    maxDigit: 8,
    nddPrefix: '0',
  },
  {
    name: { en: 'Singapore', fr: 'Singapour', ar: 'سنغافورة' },
    iso2: 'SG',
    iso3: 'SGP',
    dialCode: '+65',
    maxDigit: 8,
    nddPrefix: '',
  },
  {
    name: {
      en: 'Sint Maarten (Dutch)',
      fr: 'Saint-Martin (partie néerlandaise)',
      ar: 'سينت مارتن',
    },
    iso2: 'SX',
    iso3: 'SXM',
    dialCode: '+1-721',
    maxDigit: 7,
    nddPrefix: '1',
  },
  {
    name: { en: 'Slovakia', fr: 'Slovaquie', ar: 'سلوفاكيا' },
    iso2: 'SK',
    iso3: 'SVK',
    dialCode: '+421',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Slovenia', fr: 'Slovénie', ar: 'سلوفينيا' },
    iso2: 'SI',
    iso3: 'SVN',
    dialCode: '+386',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Solomon Islands', fr: 'Îles Salomon', ar: 'جزر سليمان' },
    iso2: 'SB',
    iso3: 'SLB',
    dialCode: '+677',
    maxDigit: 7,
    nddPrefix: '',
  },
  {
    name: { en: 'Somalia', fr: 'Somalie', ar: 'الصومال' },
    iso2: 'SO',
    iso3: 'SOM',
    dialCode: '+252',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'South Africa', fr: 'Afrique du Sud', ar: 'جنوب أفريقيا' },
    iso2: 'ZA',
    iso3: 'ZAF',
    dialCode: '+27',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'South Sudan', fr: 'Soudan du Sud', ar: 'جنوب السودان' },
    iso2: 'SS',
    iso3: 'SSD',
    dialCode: '+211',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Spain', fr: 'Espagne', ar: 'إسبانيا' },
    iso2: 'ES',
    iso3: 'ESP',
    dialCode: '+34',
    maxDigit: 9,
    nddPrefix: '',
  },
  {
    name: { en: 'Sri Lanka', fr: 'Sri Lanka', ar: 'سريلانكا' },
    iso2: 'LK',
    iso3: 'LKA',
    dialCode: '+94',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Sudan', fr: 'Soudan', ar: 'السودان' },
    iso2: 'SD',
    iso3: 'SDN',
    dialCode: '+249',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Suriname', fr: 'Suriname', ar: 'سورينام' },
    iso2: 'SR',
    iso3: 'SUR',
    dialCode: '+597',
    maxDigit: 7,
    nddPrefix: '',
  },
  {
    name: { en: 'Svalbard and Jan Mayen', fr: 'Svalbard et Jan Mayen', ar: 'سفالبارد ويان ماين' },
    iso2: 'SJ',
    iso3: 'SJM',
    dialCode: '+47',
    maxDigit: 8,
    nddPrefix: null,
  },
  {
    name: { en: 'Sweden', fr: 'Suède', ar: 'السويد' },
    iso2: 'SE',
    iso3: 'SWE',
    dialCode: '+46',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Switzerland', fr: 'Suisse', ar: 'سويسرا' },
    iso2: 'CH',
    iso3: 'CHE',
    dialCode: '+41',
    maxDigit: 9,
    nddPrefix: '',
  },
  {
    name: { en: 'Syria', fr: 'Syrie', ar: 'سوريا' },
    iso2: 'SY',
    iso3: 'SYR',
    dialCode: '+963',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Taiwan', fr: 'Taïwan', ar: 'تايوان' },
    iso2: 'TW',
    iso3: 'TWN',
    dialCode: '+886',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Tajikistan', fr: 'Tadjikistan', ar: 'طاجيكستان' },
    iso2: 'TJ',
    iso3: 'TJK',
    dialCode: '+992',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Tanzania', fr: 'Tanzanie', ar: 'تنزانيا' },
    iso2: 'TZ',
    iso3: 'TZA',
    dialCode: '+255',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Thailand', fr: 'Thaïlande', ar: 'تايلاند' },
    iso2: 'TH',
    iso3: 'THA',
    dialCode: '+66',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Togo', fr: 'Togo', ar: 'توغو' },
    iso2: 'TG',
    iso3: 'TGO',
    dialCode: '+228',
    maxDigit: 8,
    nddPrefix: '',
  },
  {
    name: { en: 'Tokelau', fr: 'Tokelau', ar: 'توكيلاو' },
    iso2: 'TK',
    iso3: 'TKL',
    dialCode: '+690',
    maxDigit: 4,
    nddPrefix: null,
  },
  {
    name: { en: 'Tonga', fr: 'Tonga', ar: 'تونغا' },
    iso2: 'TO',
    iso3: 'TON',
    dialCode: '+676',
    maxDigit: 7,
    nddPrefix: '',
  },
  {
    name: { en: 'Trinidad and Tobago', fr: 'Trinité-et-Tobago', ar: 'ترينيداد وتوباغو' },
    iso2: 'TT',
    iso3: 'TTO',
    dialCode: '+1-868',
    maxDigit: 7,
    nddPrefix: '',
  },
  {
    name: { en: 'Tunisia', fr: 'Tunisie', ar: 'تونس' },
    iso2: 'TN',
    iso3: 'TUN',
    dialCode: '+216',
    maxDigit: 8,
    nddPrefix: '0',
  },
  {
    name: { en: 'Turkey', fr: 'Turquie', ar: 'تركيا' },
    iso2: 'TR',
    iso3: 'TUR',
    dialCode: '+90',
    maxDigit: 10,
    nddPrefix: '0',
  },
  {
    name: { en: 'Turkmenistan', fr: 'Turkménistan', ar: 'تركمانستان' },
    iso2: 'TM',
    iso3: 'TKM',
    dialCode: '+993',
    maxDigit: 8,
    nddPrefix: '8',
  },
  {
    name: {
      en: 'Turks and Caicos Islands',
      fr: 'Îles Turques-et-Caïques',
      ar: 'جزر توركس وكايكوس',
    },
    iso2: 'TC',
    iso3: 'TCA',
    dialCode: '+1-649',
    maxDigit: 7,
    nddPrefix: '1',
  },
  {
    name: { en: 'Tuvalu', fr: 'Tuvalu', ar: 'توفالو' },
    iso2: 'TV',
    iso3: 'TUV',
    dialCode: '+688',
    maxDigit: 7,
    nddPrefix: '',
  },
  {
    name: {
      en: 'U.S. Virgin Islands',
      fr: 'Îles Vierges des États-Unis',
      ar: 'جزر العذراء الأمريكية',
    },
    iso2: 'VI',
    iso3: 'VIR',
    dialCode: '+1-340',
    maxDigit: 7,
    nddPrefix: '1',
  },
  {
    name: { en: 'Uganda', fr: 'Ouganda', ar: 'أوغندا' },
    iso2: 'UG',
    iso3: 'UGA',
    dialCode: '+256',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Ukraine', fr: 'Ukraine', ar: 'أوكرانيا' },
    iso2: 'UA',
    iso3: 'UKR',
    dialCode: '+380',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'United Arab Emirates', fr: 'Émirats Arabes Unis', ar: 'الإمارات العربية المتحدة' },
    iso2: 'AE',
    iso3: 'ARE',
    dialCode: '+971',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'United Kingdom', fr: 'Royaume-Uni', ar: 'المملكة المتحدة' },
    iso2: 'GB',
    iso3: 'GBR',
    dialCode: '+44',
    maxDigit: 10,
    nddPrefix: '0',
  },
  {
    name: { en: 'United States', fr: 'États-Unis', ar: 'الولايات المتحدة' },
    iso2: 'US',
    iso3: 'USA',
    dialCode: '+1',
    maxDigit: 10,
    nddPrefix: '1',
  },
  {
    name: { en: 'Uruguay', fr: 'Uruguay', ar: 'أوروغواي' },
    iso2: 'UY',
    iso3: 'URY',
    dialCode: '+598',
    maxDigit: 8,
    nddPrefix: '0',
  },
  {
    name: { en: 'Uzbekistan', fr: 'Ouzbékistan', ar: 'أوزبكستان' },
    iso2: 'UZ',
    iso3: 'UZB',
    dialCode: '+998',
    maxDigit: 9,
    nddPrefix: '8',
  },
  {
    name: { en: 'Vanuatu', fr: 'Vanuatu', ar: 'فانواتو' },
    iso2: 'VU',
    iso3: 'VUT',
    dialCode: '+678',
    maxDigit: 7,
    nddPrefix: '',
  },
  {
    name: { en: 'Vatican City', fr: 'Cité du Vatican', ar: 'مدينة الفاتيكان' },
    iso2: 'VA',
    iso3: 'VAT',
    dialCode: '+379',
    maxDigit: 5,
    nddPrefix: '',
  },
  {
    name: { en: 'Venezuela', fr: 'Venezuela', ar: 'فنزويلا' },
    iso2: 'VE',
    iso3: 'VEN',
    dialCode: '+58',
    maxDigit: 10,
    nddPrefix: '0',
  },
  {
    name: { en: 'Vietnam', fr: 'Viêt Nam', ar: 'فيتنام' },
    iso2: 'VN',
    iso3: 'VNM',
    dialCode: '+84',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Wallis and Futuna', fr: 'Wallis-et-Futuna', ar: 'واليس وفوتونا' },
    iso2: 'WF',
    iso3: 'WLF',
    dialCode: '+681',
    maxDigit: 6,
    nddPrefix: null,
  },
  {
    name: { en: 'Western Sahara', fr: 'Sahara occidental', ar: 'الصحراء الغربية' },
    iso2: 'EH',
    iso3: 'ESH',
    dialCode: '+212',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Yemen', fr: 'Yémen', ar: 'اليمن' },
    iso2: 'YE',
    iso3: 'YEM',
    dialCode: '+967',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Zambia', fr: 'Zambie', ar: 'زامبيا' },
    iso2: 'ZM',
    iso3: 'ZMB',
    dialCode: '+260',
    maxDigit: 9,
    nddPrefix: '0',
  },
  {
    name: { en: 'Zimbabwe', fr: 'Zimbabwe', ar: 'زيمبابوي' },
    iso2: 'ZW',
    iso3: 'ZWE',
    dialCode: '+263',
    maxDigit: 9,
    nddPrefix: '0',
  },
];

export const defaultPhoneCodeCountry = {
  name: 'Oman',
  iso2: 'OM',
  iso3: 'OMN',
  dialCode: '+968',
  maxDigit: 8,
  nddPrefix: '0',
};
/* phone dial codes */

export const htmlDir = {
  ltr: 'ltr',
  rtl: 'rtl',
};

/* options for change user's native language */
export const languageSelectOptions = {
  en: { value: 'en', label: 'EN', dir: htmlDir.ltr },
  ar: { value: 'ar', label: 'العربية', dir: htmlDir.rtl },
};

export const availableLanguages = new Set(Object.keys(languageSelectOptions));
export const USER_LANG_STORAGE_KEY = 'userNativeLang';
